import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  toString1pkumu07cwy4m as toString,
  IllegalArgumentException_init_$Create$3ewkh27kzt8z8 as IllegalArgumentException_init_$Create$,
  Unit_instance1fbcbse1fwigr as Unit_instance,
  fromInt2ii0rejb1w62w as fromInt,
  modulooi4g1kq3dmtt as modulo,
  dividelr0uqtdj497z as divide,
  convertToInty04h231mmjoh as convertToInt,
  shiftRight2gqph14wydb8s as shiftRight,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID3gxj6tk5isa35 as VOID,
  enumEntries20mr21zbe3az4 as enumEntries,
  Enum3alwj03lh1n41 as Enum,
  IllegalArgumentException_init_$Init$1blytbdgl1fky as IllegalArgumentException_init_$Init$,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  captureStack1fzi4aczwc4hg as captureStack,
  IllegalArgumentException_init_$Init$1ke5df1bctk2y as IllegalArgumentException_init_$Init$_0,
  IllegalArgumentException_init_$Init$jyc1udwa6hs3 as IllegalArgumentException_init_$Init$_1,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  RuntimeException_init_$Init$2k6z5rjhd4a8z as RuntimeException_init_$Init$,
  RuntimeException_init_$Init$3m7ccek2krm3f as RuntimeException_init_$Init$_0,
  RuntimeException1r3t0zl97011n as RuntimeException,
  StringBuilder_init_$Create$2qsge4ydj6bin as StringBuilder_init_$Create$,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  toString3o7ifthqydp6e as toString_0,
  KProperty02ce7r476m8633 as KProperty0,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  hashCodeq5arwsb9dgti as hashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  lazy2hsh8ze7j6ikd as lazy,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  ArrayList_init_$Create$149jv2ovkkvnt as ArrayList_init_$Create$,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  isInterface3d6p8outrmvmk as isInterface,
  equals2au1ep9vhcato as equals,
  IllegalStateException_init_$Create$2w9444nebyjns as IllegalStateException_init_$Create$,
  toString30pk9tzaqopn as toString_1,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charCodeAt1yspne1d8erbm as charCodeAt,
  substringiqarkczpya5m as substring,
  listOfvhqybd2zx248 as listOf,
  substring3saq8ornu0luv as substring_0,
  get_lastIndexld83bqhfgcdd as get_lastIndex,
  emptyList1g2z5xcrvp2zy as emptyList,
  joinToString1cxrrlmo0chqs as joinToString,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  ArrayList_init_$Create$3bxttkj3v1mea as ArrayList_init_$Create$_0,
  singleo93pzdgfc557 as single,
  abs1kdzbjes1idip as abs,
  charSequenceSubSequence1iwpdba8s3jc7 as charSequenceSubSequence,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  mutableListOf6oorvk2mtdmp as mutableListOf,
  removeLastOrNull3odnlbetbttd4 as removeLastOrNull,
  sortWith4fnm6b3vw03s as sortWith,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  Exceptiondt2hlxn7j7vw as Exception,
  Exception_init_$Init$33ewqhqmjrfx6 as Exception_init_$Init$,
  StringBuilder_init_$Create$2ujvu6cqvzuyn as StringBuilder_init_$Create$_0,
  joinTo3lkanfaxbzac2 as joinTo,
  plus310ted5e4i90h as plus,
  toMutableList20rdgwi7d3cwi as toMutableList,
  addAll1k27qatfgp3k5 as addAll,
  Collection1k04j3hzsbod0 as Collection,
  firstOrNull1982767dljvdy as firstOrNull,
  drop3na99dw9feawf as drop,
  listOf1jh22dvmctj1r as listOf_0,
  repeat2w4c6j8zoq09o as repeat,
  checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow,
  Char__minus_impl_a2frrh3548ixwefqxih as Char__minus_impl_a2frrh,
  PrimitiveClasses_getInstance2v63zn04dtq03 as PrimitiveClasses_getInstance,
  arrayOf1akklvh2at202 as arrayOf,
  createKType31ecntyyaay3k as createKType,
  LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy_0,
  KProperty1ca4yb4wlo496 as KProperty1,
  getKClass3t8tygqu4lcxf as getKClass,
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
  multiply2k9eolhnz1bjv as multiply,
  negate13xrbakfwasjy as negate,
  numberToLong2pakxeg38estk as numberToLong,
  get_ONEazvfdh9ju3d4 as get_ONE,
  compareTo3ankvs086tmwq as compareTo,
  ClosedRangehokgr73im9z3 as ClosedRange,
  contains2c50nlxg7en7o as contains,
  Comparable198qfk8pnblz0 as Comparable,
  ArithmeticException18dajwq7kbp38 as ArithmeticException,
  compareValuesBy2ycqeh37x2wfm as compareValuesBy,
  ArithmeticException_init_$Create$1hyic6pp7krob as ArithmeticException_init_$Create$,
} from './kotlin-kotlin-stdlib.mjs';
import {
  buildClassSerialDescriptors2a6xdp6mrtw as buildClassSerialDescriptor,
  serializer1hwzc6m64v1op as serializer,
  KSerializerzf77vz1967fq as KSerializer,
  MissingFieldException_init_$Create$8e88b5fk0hk1 as MissingFieldException_init_$Create$,
  SealedClassSerializeriwipiibk55zc as SealedClassSerializer,
  AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer,
  SerializationException_init_$Create$1b97dv9p64p50 as SerializationException_init_$Create$,
  STRING_getInstance2ou4lro9xn2qn as STRING_getInstance,
  PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForCompanion(Companion);
initMetadataForCompanion(Companion_0);
initMetadataForCompanion(Companion_1);
initMetadataForCompanion(Companion_2);
initMetadataForClass(DateTimeUnit, 'DateTimeUnit', VOID, VOID, VOID, VOID, VOID, {0: DateTimeUnitSerializer_getInstance});
initMetadataForClass(TimeBased, 'TimeBased', VOID, DateTimeUnit, VOID, VOID, VOID, {0: TimeBasedDateTimeUnitSerializer_getInstance});
initMetadataForClass(DateBased, 'DateBased', VOID, DateTimeUnit, VOID, VOID, VOID, {0: DateBasedDateTimeUnitSerializer_getInstance});
initMetadataForClass(DayBased, 'DayBased', VOID, DateBased, VOID, VOID, VOID, {0: DayBasedDateTimeUnitSerializer_getInstance});
initMetadataForClass(MonthBased, 'MonthBased', VOID, DateBased, VOID, VOID, VOID, {0: MonthBasedDateTimeUnitSerializer_getInstance});
initMetadataForCompanion(Companion_3);
initMetadataForClass(DayOfWeek, 'DayOfWeek', VOID, Enum);
initMetadataForClass(DateTimeFormatException, 'DateTimeFormatException', DateTimeFormatException_init_$Create$, IllegalArgumentException);
initMetadataForClass(DateTimeArithmeticException, 'DateTimeArithmeticException', DateTimeArithmeticException_init_$Create$, RuntimeException);
initMetadataForClass(Month, 'Month', VOID, Enum);
initMetadataForClass(AbstractDateTimeFormat, 'AbstractDateTimeFormat');
initMetadataForClass(Padding, 'Padding', VOID, Enum);
function year$default(padding, $super) {
  padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
  var tmp;
  if ($super === VOID) {
    this.p1m(padding);
    tmp = Unit_instance;
  } else {
    tmp = $super.p1m.call(this, padding);
  }
  return tmp;
}
function monthNumber$default(padding, $super) {
  padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
  var tmp;
  if ($super === VOID) {
    this.r1m(padding);
    tmp = Unit_instance;
  } else {
    tmp = $super.r1m.call(this, padding);
  }
  return tmp;
}
initMetadataForInterface(WithYearMonth, 'WithYearMonth');
function day$default(padding, $super) {
  padding = padding === VOID ? Padding_ZERO_getInstance() : padding;
  var tmp;
  if ($super === VOID) {
    this.u1m(padding);
    tmp = Unit_instance;
  } else {
    tmp = $super.u1m.call(this, padding);
  }
  return tmp;
}
initMetadataForInterface(WithDate, 'WithDate', VOID, VOID, [WithYearMonth]);
function chars(value) {
  return this.w1m().y1m(new ConstantFormatStructure(value));
}
function build() {
  return new CachedFormatStructure(this.w1m().z1m().a1n_1);
}
initMetadataForInterface(AbstractDateTimeFormatBuilder, 'AbstractDateTimeFormatBuilder');
initMetadataForClass(IncompleteLocalDate, 'IncompleteLocalDate', IncompleteLocalDate);
initMetadataForCompanion(Companion_4);
function year(padding) {
  return this.b1o(new BasicFormatStructure(new YearDirective(padding)));
}
function monthNumber(padding) {
  return this.b1o(new BasicFormatStructure(new MonthDirective(padding)));
}
initMetadataForInterface(AbstractWithYearMonthBuilder, 'AbstractWithYearMonthBuilder', VOID, VOID, [WithYearMonth]);
function addFormatStructureForYearMonth(structure) {
  this.a1o(structure);
}
function day(padding) {
  return this.a1o(new BasicFormatStructure(new DayDirective(padding)));
}
initMetadataForInterface(AbstractWithDateBuilder, 'AbstractWithDateBuilder', VOID, VOID, [AbstractWithYearMonthBuilder, WithDate]);
initMetadataForClass(Builder, 'Builder', VOID, VOID, [AbstractDateTimeFormatBuilder, AbstractWithDateBuilder]);
initMetadataForClass(LocalDateFormat, 'LocalDateFormat', VOID, AbstractDateTimeFormat);
initMetadataForClass(UnsignedIntFieldFormatDirective, 'UnsignedIntFieldFormatDirective');
initMetadataForClass(DayDirective, 'DayDirective', VOID, UnsignedIntFieldFormatDirective);
initMetadataForObject(DateFields, 'DateFields');
initMetadataForClass(IncompleteYearMonth, 'IncompleteYearMonth', IncompleteYearMonth);
initMetadataForCompanion(Companion_5);
initMetadataForClass(Builder_0, 'Builder', VOID, VOID, [AbstractDateTimeFormatBuilder, AbstractWithYearMonthBuilder]);
initMetadataForClass(YearMonthFormat, 'YearMonthFormat', VOID, AbstractDateTimeFormat);
initMetadataForClass(SignedIntFieldFormatDirective, 'SignedIntFieldFormatDirective');
initMetadataForClass(YearDirective, 'YearDirective', VOID, SignedIntFieldFormatDirective);
initMetadataForClass(MonthDirective, 'MonthDirective', VOID, UnsignedIntFieldFormatDirective);
initMetadataForObject(YearMonthFields, 'YearMonthFields');
initMetadataForClass(AppendableFormatStructure, 'AppendableFormatStructure', AppendableFormatStructure);
initMetadataForClass(AbstractFieldSpec, 'AbstractFieldSpec');
initMetadataForClass(GenericFieldSpec, 'GenericFieldSpec', VOID, AbstractFieldSpec);
function getterNotNull(container) {
  var tmp0_elvis_lhs = this.l1q(container);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException_init_$Create$('Field ' + this.k2() + ' is not set');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
initMetadataForInterface(Accessor, 'Accessor');
initMetadataForClass(PropertyAccessor, 'PropertyAccessor', VOID, VOID, [Accessor]);
initMetadataForClass(UnsignedFieldSpec, 'UnsignedFieldSpec', VOID, AbstractFieldSpec);
initMetadataForClass(ConcatenatedFormatStructure, 'ConcatenatedFormatStructure');
initMetadataForClass(CachedFormatStructure, 'CachedFormatStructure', VOID, ConcatenatedFormatStructure);
initMetadataForInterface(NonConcatenatedFormatStructure, 'NonConcatenatedFormatStructure');
initMetadataForClass(BasicFormatStructure, 'BasicFormatStructure', VOID, VOID, [NonConcatenatedFormatStructure]);
initMetadataForClass(ConstantFormatStructure, 'ConstantFormatStructure', VOID, VOID, [NonConcatenatedFormatStructure]);
function format$default(obj, builder, minusNotRequired, $super) {
  minusNotRequired = minusNotRequired === VOID ? false : minusNotRequired;
  var tmp;
  if ($super === VOID) {
    this.o1q(obj, builder, minusNotRequired);
    tmp = Unit_instance;
  } else {
    tmp = $super.o1q.call(this, obj, builder, minusNotRequired);
  }
  return tmp;
}
initMetadataForInterface(FormatterStructure, 'FormatterStructure');
initMetadataForClass(SpacePaddedFormatter, 'SpacePaddedFormatter', VOID, VOID, [FormatterStructure]);
initMetadataForClass(ConcatenatedFormatter, 'ConcatenatedFormatter', VOID, VOID, [FormatterStructure]);
initMetadataForClass(UnsignedIntFormatterStructure, 'UnsignedIntFormatterStructure', VOID, VOID, [FormatterStructure]);
initMetadataForClass(SignedIntFormatterStructure, 'SignedIntFormatterStructure', VOID, VOID, [FormatterStructure]);
initMetadataForClass(ConstantStringFormatterStructure, 'ConstantStringFormatterStructure', VOID, VOID, [FormatterStructure]);
initMetadataForClass(NumberConsumer, 'NumberConsumer');
initMetadataForClass(ConstantNumberConsumer, 'ConstantNumberConsumer', VOID, NumberConsumer);
initMetadataForObject(ExpectedInt, 'ExpectedInt');
initMetadataForClass(TooManyDigits, 'TooManyDigits');
initMetadataForClass(TooFewDigits, 'TooFewDigits');
initMetadataForClass(WrongConstant, 'WrongConstant');
initMetadataForClass(Conflicting, 'Conflicting');
initMetadataForClass(UnsignedIntConsumer, 'UnsignedIntConsumer', VOID, NumberConsumer);
initMetadataForClass(ParseError, 'ParseError');
initMetadataForCompanion(Companion_6);
initMetadataForClass(ParserState, 'ParserState');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(Parser, 'Parser');
initMetadataForClass(ParserStructure, 'ParserStructure');
initMetadataForClass(ParseException, 'ParseException', VOID, Exception);
initMetadataForClass(NumberSpanParserOperation, 'NumberSpanParserOperation');
initMetadataForClass(PlainStringParserOperation, 'PlainStringParserOperation');
initMetadataForClass(UnconditionalModification, 'UnconditionalModification');
initMetadataForObject(TimeBasedDateTimeUnitSerializer, 'TimeBasedDateTimeUnitSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(DateBasedDateTimeUnitSerializer, 'DateBasedDateTimeUnitSerializer', VOID, AbstractPolymorphicSerializer);
initMetadataForObject(DayBasedDateTimeUnitSerializer, 'DayBasedDateTimeUnitSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(MonthBasedDateTimeUnitSerializer, 'MonthBasedDateTimeUnitSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(DateTimeUnitSerializer, 'DateTimeUnitSerializer', VOID, AbstractPolymorphicSerializer);
initMetadataForObject(LocalDateSerializer, 'LocalDateSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(YearMonthSerializer, 'YearMonthSerializer', VOID, VOID, [KSerializer]);
initMetadataForCompanion(Companion_7);
initMetadataForObject(Formats, 'Formats');
initMetadataForClass(LocalDate, 'LocalDate', VOID, VOID, [Comparable], VOID, VOID, {0: LocalDateSerializer_getInstance});
initMetadataForCompanion(Companion_8);
initMetadataForObject(Formats_0, 'Formats');
initMetadataForClass(YearMonth, 'YearMonth', VOID, VOID, [Comparable], VOID, VOID, {0: YearMonthSerializer_getInstance});
//endregion
function Companion() {
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function Companion_0() {
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
function Companion_1() {
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
function Companion_2() {
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
function TimeBased(nanoseconds) {
  DateTimeUnit.call(this);
  this.i1l_1 = nanoseconds;
  // Inline function 'kotlin.require' call
  if (!(this.i1l_1 > 0n)) {
    var message = 'Unit duration must be positive, but was ' + this.i1l_1.toString() + ' ns.';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  if (modulo(this.i1l_1, 3600000000000n) === 0n) {
    this.j1l_1 = 'HOUR';
    this.k1l_1 = divide(this.i1l_1, 3600000000000n);
  } else {
    if (modulo(this.i1l_1, 60000000000n) === 0n) {
      this.j1l_1 = 'MINUTE';
      this.k1l_1 = divide(this.i1l_1, 60000000000n);
    } else {
      var tmp0 = this.i1l_1;
      // Inline function 'kotlin.Long.rem' call
      var other = 1000000000;
      if (modulo(tmp0, fromInt(other)) === 0n) {
        this.j1l_1 = 'SECOND';
        var tmp = this;
        var tmp0_0 = this.i1l_1;
        // Inline function 'kotlin.Long.div' call
        var other_0 = 1000000000;
        tmp.k1l_1 = divide(tmp0_0, fromInt(other_0));
      } else {
        // Inline function 'kotlin.Long.rem' call
        var this_0 = this.i1l_1;
        if (modulo(this_0, fromInt(1000000)) === 0n) {
          this.j1l_1 = 'MILLISECOND';
          var tmp_0 = this;
          // Inline function 'kotlin.Long.div' call
          var this_1 = this.i1l_1;
          tmp_0.k1l_1 = divide(this_1, fromInt(1000000));
        } else {
          // Inline function 'kotlin.Long.rem' call
          var this_2 = this.i1l_1;
          if (modulo(this_2, fromInt(1000)) === 0n) {
            this.j1l_1 = 'MICROSECOND';
            var tmp_1 = this;
            // Inline function 'kotlin.Long.div' call
            var this_3 = this.i1l_1;
            tmp_1.k1l_1 = divide(this_3, fromInt(1000));
          } else {
            this.j1l_1 = 'NANOSECOND';
            this.k1l_1 = this.i1l_1;
          }
        }
      }
    }
  }
}
protoOf(TimeBased).l1l = function (scalar) {
  return new TimeBased(safeMultiply(this.i1l_1, fromInt(scalar)));
};
protoOf(TimeBased).equals = function (other) {
  var tmp;
  if (this === other) {
    tmp = true;
  } else {
    var tmp_0;
    if (other instanceof TimeBased) {
      tmp_0 = this.i1l_1 === other.i1l_1;
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  }
  return tmp;
};
protoOf(TimeBased).hashCode = function () {
  return convertToInt(this.i1l_1) ^ convertToInt(shiftRight(this.i1l_1, 32));
};
protoOf(TimeBased).toString = function () {
  return this.m1l(this.k1l_1, this.j1l_1);
};
function DateBased() {
  DateTimeUnit.call(this);
}
function DayBased(days) {
  DateBased.call(this);
  this.o1l_1 = days;
  // Inline function 'kotlin.require' call
  if (!(this.o1l_1 > 0)) {
    var message = 'Unit duration must be positive, but was ' + this.o1l_1 + ' days.';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
}
protoOf(DayBased).l1l = function (scalar) {
  return new DayBased(safeMultiply_0(this.o1l_1, scalar));
};
protoOf(DayBased).equals = function (other) {
  var tmp;
  if (this === other) {
    tmp = true;
  } else {
    var tmp_0;
    if (other instanceof DayBased) {
      tmp_0 = this.o1l_1 === other.o1l_1;
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  }
  return tmp;
};
protoOf(DayBased).hashCode = function () {
  return this.o1l_1 ^ 65536;
};
protoOf(DayBased).toString = function () {
  return (this.o1l_1 % 7 | 0) === 0 ? this.n1l(this.o1l_1 / 7 | 0, 'WEEK') : this.n1l(this.o1l_1, 'DAY');
};
function MonthBased(months) {
  DateBased.call(this);
  this.p1l_1 = months;
  // Inline function 'kotlin.require' call
  if (!(this.p1l_1 > 0)) {
    var message = 'Unit duration must be positive, but was ' + this.p1l_1 + ' months.';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
}
protoOf(MonthBased).l1l = function (scalar) {
  return new MonthBased(safeMultiply_0(this.p1l_1, scalar));
};
protoOf(MonthBased).equals = function (other) {
  var tmp;
  if (this === other) {
    tmp = true;
  } else {
    var tmp_0;
    if (other instanceof MonthBased) {
      tmp_0 = this.p1l_1 === other.p1l_1;
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  }
  return tmp;
};
protoOf(MonthBased).hashCode = function () {
  return this.p1l_1 ^ 131072;
};
protoOf(MonthBased).toString = function () {
  return (this.p1l_1 % 1200 | 0) === 0 ? this.n1l(this.p1l_1 / 1200 | 0, 'CENTURY') : (this.p1l_1 % 12 | 0) === 0 ? this.n1l(this.p1l_1 / 12 | 0, 'YEAR') : (this.p1l_1 % 3 | 0) === 0 ? this.n1l(this.p1l_1 / 3 | 0, 'QUARTER') : this.n1l(this.p1l_1, 'MONTH');
};
function Companion_3() {
  Companion_instance_3 = this;
  this.q1l_1 = new TimeBased(1n);
  this.r1l_1 = this.q1l_1.l1l(1000);
  this.s1l_1 = this.r1l_1.l1l(1000);
  this.t1l_1 = this.s1l_1.l1l(1000);
  this.u1l_1 = this.t1l_1.l1l(60);
  this.v1l_1 = this.u1l_1.l1l(60);
  this.w1l_1 = new DayBased(1);
  this.x1l_1 = this.w1l_1.l1l(7);
  this.y1l_1 = new MonthBased(1);
  this.z1l_1 = this.y1l_1.l1l(3);
  this.a1m_1 = this.y1l_1.l1l(12);
  this.b1m_1 = this.a1m_1.l1l(100);
}
var Companion_instance_3;
function Companion_getInstance_3() {
  if (Companion_instance_3 == null)
    new Companion_3();
  return Companion_instance_3;
}
function DateTimeUnit() {
  Companion_getInstance_3();
}
protoOf(DateTimeUnit).n1l = function (value, unit) {
  return value === 1 ? unit : '' + value + '-' + unit;
};
protoOf(DateTimeUnit).m1l = function (value, unit) {
  return value === 1n ? unit : value.toString() + '-' + unit;
};
function get_isoDayNumber(_this__u8e3s4) {
  return _this__u8e3s4.j2_1 + 1 | 0;
}
var DayOfWeek_MONDAY_instance;
var DayOfWeek_TUESDAY_instance;
var DayOfWeek_WEDNESDAY_instance;
var DayOfWeek_THURSDAY_instance;
var DayOfWeek_FRIDAY_instance;
var DayOfWeek_SATURDAY_instance;
var DayOfWeek_SUNDAY_instance;
function values() {
  return [DayOfWeek_MONDAY_getInstance(), DayOfWeek_TUESDAY_getInstance(), DayOfWeek_WEDNESDAY_getInstance(), DayOfWeek_THURSDAY_getInstance(), DayOfWeek_FRIDAY_getInstance(), DayOfWeek_SATURDAY_getInstance(), DayOfWeek_SUNDAY_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var DayOfWeek_entriesInitialized;
function DayOfWeek_initEntries() {
  if (DayOfWeek_entriesInitialized)
    return Unit_instance;
  DayOfWeek_entriesInitialized = true;
  DayOfWeek_MONDAY_instance = new DayOfWeek('MONDAY', 0);
  DayOfWeek_TUESDAY_instance = new DayOfWeek('TUESDAY', 1);
  DayOfWeek_WEDNESDAY_instance = new DayOfWeek('WEDNESDAY', 2);
  DayOfWeek_THURSDAY_instance = new DayOfWeek('THURSDAY', 3);
  DayOfWeek_FRIDAY_instance = new DayOfWeek('FRIDAY', 4);
  DayOfWeek_SATURDAY_instance = new DayOfWeek('SATURDAY', 5);
  DayOfWeek_SUNDAY_instance = new DayOfWeek('SUNDAY', 6);
}
var $ENTRIES;
function DayOfWeek(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function DayOfWeek_0(isoDayNumber) {
  // Inline function 'kotlin.require' call
  if (!(1 <= isoDayNumber ? isoDayNumber <= 7 : false)) {
    var message = 'Expected ISO day-of-week number in 1..7, got ' + isoDayNumber;
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return get_entries().p(isoDayNumber - 1 | 0);
}
function DayOfWeek_MONDAY_getInstance() {
  DayOfWeek_initEntries();
  return DayOfWeek_MONDAY_instance;
}
function DayOfWeek_TUESDAY_getInstance() {
  DayOfWeek_initEntries();
  return DayOfWeek_TUESDAY_instance;
}
function DayOfWeek_WEDNESDAY_getInstance() {
  DayOfWeek_initEntries();
  return DayOfWeek_WEDNESDAY_instance;
}
function DayOfWeek_THURSDAY_getInstance() {
  DayOfWeek_initEntries();
  return DayOfWeek_THURSDAY_instance;
}
function DayOfWeek_FRIDAY_getInstance() {
  DayOfWeek_initEntries();
  return DayOfWeek_FRIDAY_instance;
}
function DayOfWeek_SATURDAY_getInstance() {
  DayOfWeek_initEntries();
  return DayOfWeek_SATURDAY_instance;
}
function DayOfWeek_SUNDAY_getInstance() {
  DayOfWeek_initEntries();
  return DayOfWeek_SUNDAY_instance;
}
function DateTimeFormatException_init_$Init$($this) {
  IllegalArgumentException_init_$Init$($this);
  DateTimeFormatException.call($this);
  return $this;
}
function DateTimeFormatException_init_$Create$() {
  var tmp = DateTimeFormatException_init_$Init$(objectCreate(protoOf(DateTimeFormatException)));
  captureStack(tmp, DateTimeFormatException_init_$Create$);
  return tmp;
}
function DateTimeFormatException_init_$Init$_0(message, $this) {
  IllegalArgumentException_init_$Init$_0(message, $this);
  DateTimeFormatException.call($this);
  return $this;
}
function DateTimeFormatException_init_$Create$_0(message) {
  var tmp = DateTimeFormatException_init_$Init$_0(message, objectCreate(protoOf(DateTimeFormatException)));
  captureStack(tmp, DateTimeFormatException_init_$Create$_0);
  return tmp;
}
function DateTimeFormatException_init_$Init$_1(message, cause, $this) {
  IllegalArgumentException_init_$Init$_1(message, cause, $this);
  DateTimeFormatException.call($this);
  return $this;
}
function DateTimeFormatException_init_$Create$_1(message, cause) {
  var tmp = DateTimeFormatException_init_$Init$_1(message, cause, objectCreate(protoOf(DateTimeFormatException)));
  captureStack(tmp, DateTimeFormatException_init_$Create$_1);
  return tmp;
}
function DateTimeFormatException() {
  captureStack(this, DateTimeFormatException);
}
function DateTimeArithmeticException_init_$Init$($this) {
  RuntimeException_init_$Init$($this);
  DateTimeArithmeticException.call($this);
  return $this;
}
function DateTimeArithmeticException_init_$Create$() {
  var tmp = DateTimeArithmeticException_init_$Init$(objectCreate(protoOf(DateTimeArithmeticException)));
  captureStack(tmp, DateTimeArithmeticException_init_$Create$);
  return tmp;
}
function DateTimeArithmeticException_init_$Init$_0(message, cause, $this) {
  RuntimeException_init_$Init$_0(message, cause, $this);
  DateTimeArithmeticException.call($this);
  return $this;
}
function DateTimeArithmeticException_init_$Create$_0(message, cause) {
  var tmp = DateTimeArithmeticException_init_$Init$_0(message, cause, objectCreate(protoOf(DateTimeArithmeticException)));
  captureStack(tmp, DateTimeArithmeticException_init_$Create$_0);
  return tmp;
}
function DateTimeArithmeticException() {
  captureStack(this, DateTimeArithmeticException);
}
function plus_0(_this__u8e3s4, value, unit) {
  return plus_1(_this__u8e3s4, fromInt(value), unit);
}
function getIsoDateFormat() {
  return Formats_getInstance().d1m();
}
function format(_this__u8e3s4, format) {
  return format.e1m(_this__u8e3s4);
}
function get_number(_this__u8e3s4) {
  return _this__u8e3s4.j2_1 + 1 | 0;
}
var Month_JANUARY_instance;
var Month_FEBRUARY_instance;
var Month_MARCH_instance;
var Month_APRIL_instance;
var Month_MAY_instance;
var Month_JUNE_instance;
var Month_JULY_instance;
var Month_AUGUST_instance;
var Month_SEPTEMBER_instance;
var Month_OCTOBER_instance;
var Month_NOVEMBER_instance;
var Month_DECEMBER_instance;
function values_0() {
  return [Month_JANUARY_getInstance(), Month_FEBRUARY_getInstance(), Month_MARCH_getInstance(), Month_APRIL_getInstance(), Month_MAY_getInstance(), Month_JUNE_getInstance(), Month_JULY_getInstance(), Month_AUGUST_getInstance(), Month_SEPTEMBER_getInstance(), Month_OCTOBER_getInstance(), Month_NOVEMBER_getInstance(), Month_DECEMBER_getInstance()];
}
function get_entries_0() {
  if ($ENTRIES_0 == null)
    $ENTRIES_0 = enumEntries(values_0());
  return $ENTRIES_0;
}
var Month_entriesInitialized;
function Month_initEntries() {
  if (Month_entriesInitialized)
    return Unit_instance;
  Month_entriesInitialized = true;
  Month_JANUARY_instance = new Month('JANUARY', 0);
  Month_FEBRUARY_instance = new Month('FEBRUARY', 1);
  Month_MARCH_instance = new Month('MARCH', 2);
  Month_APRIL_instance = new Month('APRIL', 3);
  Month_MAY_instance = new Month('MAY', 4);
  Month_JUNE_instance = new Month('JUNE', 5);
  Month_JULY_instance = new Month('JULY', 6);
  Month_AUGUST_instance = new Month('AUGUST', 7);
  Month_SEPTEMBER_instance = new Month('SEPTEMBER', 8);
  Month_OCTOBER_instance = new Month('OCTOBER', 9);
  Month_NOVEMBER_instance = new Month('NOVEMBER', 10);
  Month_DECEMBER_instance = new Month('DECEMBER', 11);
}
var $ENTRIES_0;
function Month(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function Month_0(number) {
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!(1 <= number ? number <= 12 : false)) {
    var message = 'Failed requirement.';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return get_entries_0().p(number - 1 | 0);
}
function Month_JANUARY_getInstance() {
  Month_initEntries();
  return Month_JANUARY_instance;
}
function Month_FEBRUARY_getInstance() {
  Month_initEntries();
  return Month_FEBRUARY_instance;
}
function Month_MARCH_getInstance() {
  Month_initEntries();
  return Month_MARCH_instance;
}
function Month_APRIL_getInstance() {
  Month_initEntries();
  return Month_APRIL_instance;
}
function Month_MAY_getInstance() {
  Month_initEntries();
  return Month_MAY_instance;
}
function Month_JUNE_getInstance() {
  Month_initEntries();
  return Month_JUNE_instance;
}
function Month_JULY_getInstance() {
  Month_initEntries();
  return Month_JULY_instance;
}
function Month_AUGUST_getInstance() {
  Month_initEntries();
  return Month_AUGUST_instance;
}
function Month_SEPTEMBER_getInstance() {
  Month_initEntries();
  return Month_SEPTEMBER_instance;
}
function Month_OCTOBER_getInstance() {
  Month_initEntries();
  return Month_OCTOBER_instance;
}
function Month_NOVEMBER_getInstance() {
  Month_initEntries();
  return Month_NOVEMBER_instance;
}
function Month_DECEMBER_getInstance() {
  Month_initEntries();
  return Month_DECEMBER_instance;
}
function AbstractDateTimeFormat() {
}
protoOf(AbstractDateTimeFormat).e1m = function (value) {
  // Inline function 'kotlin.also' call
  var this_0 = StringBuilder_init_$Create$();
  this.f1m().m1m().n1m(this.g1m(value), this_0);
  return this_0.toString();
};
protoOf(AbstractDateTimeFormat).yl = function (input) {
  var tmp;
  try {
    tmp = Parser__match$default_impl_x2xlti(_Parser___init__impl__gdyfby(this.f1m().o1m()), input, this.i1m());
  } catch ($p) {
    var tmp_0;
    if ($p instanceof ParseException) {
      var e = $p;
      throw DateTimeFormatException_init_$Create$_1("Failed to parse value from '" + toString(input) + "'", e);
    } else {
      throw $p;
    }
  }
  var matched = tmp;
  try {
    return this.h1m(matched);
  } catch ($p) {
    if ($p instanceof IllegalArgumentException) {
      var e_0 = $p;
      var message = e_0.message;
      throw DateTimeFormatException_init_$Create$_1(message == null ? "The value parsed from '" + toString(input) + "' is invalid" : '' + message + " (when parsing '" + toString(input) + "')", e_0);
    } else {
      throw $p;
    }
  }
};
var Padding_NONE_instance;
var Padding_ZERO_instance;
var Padding_SPACE_instance;
var Padding_entriesInitialized;
function Padding_initEntries() {
  if (Padding_entriesInitialized)
    return Unit_instance;
  Padding_entriesInitialized = true;
  Padding_NONE_instance = new Padding('NONE', 0);
  Padding_ZERO_instance = new Padding('ZERO', 1);
  Padding_SPACE_instance = new Padding('SPACE', 2);
}
function Padding(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function Padding_ZERO_getInstance() {
  Padding_initEntries();
  return Padding_ZERO_instance;
}
function Padding_SPACE_getInstance() {
  Padding_initEntries();
  return Padding_SPACE_instance;
}
function WithYearMonth() {
}
function WithDate() {
}
function char(_this__u8e3s4, value) {
  return _this__u8e3s4.t1m(toString_0(value));
}
function AbstractDateTimeFormatBuilder() {
}
function get_ISO_DATE() {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  var tmp0 = ISO_DATE$delegate;
  var tmp = KProperty0;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('ISO_DATE', 0, tmp, _get_ISO_DATE_$ref_powsum(), null);
  return tmp0.w();
}
var ISO_DATE$delegate;
function get_ISO_DATE_BASIC() {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  var tmp0 = ISO_DATE_BASIC$delegate;
  var tmp = KProperty0;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('ISO_DATE_BASIC', 0, tmp, _get_ISO_DATE_BASIC_$ref_3fs8eb(), null);
  return tmp0.w();
}
var ISO_DATE_BASIC$delegate;
function get_emptyIncompleteLocalDate() {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  return emptyIncompleteLocalDate;
}
var emptyIncompleteLocalDate;
function IncompleteLocalDate(yearMonth, day, dayOfWeek, dayOfYear) {
  yearMonth = yearMonth === VOID ? new IncompleteYearMonth() : yearMonth;
  day = day === VOID ? null : day;
  dayOfWeek = dayOfWeek === VOID ? null : dayOfWeek;
  dayOfYear = dayOfYear === VOID ? null : dayOfYear;
  this.b1n_1 = yearMonth;
  this.c1n_1 = day;
  this.d1n_1 = dayOfWeek;
  this.e1n_1 = dayOfYear;
}
protoOf(IncompleteLocalDate).f1n = function (_set____db54di) {
  this.c1n_1 = _set____db54di;
};
protoOf(IncompleteLocalDate).g1n = function () {
  return this.c1n_1;
};
protoOf(IncompleteLocalDate).h1n = function (_set____db54di) {
  this.d1n_1 = _set____db54di;
};
protoOf(IncompleteLocalDate).i1n = function () {
  return this.d1n_1;
};
protoOf(IncompleteLocalDate).j1n = function (_set____db54di) {
  this.e1n_1 = _set____db54di;
};
protoOf(IncompleteLocalDate).k1n = function () {
  return this.e1n_1;
};
protoOf(IncompleteLocalDate).l1n = function () {
  var year = requireParsedField(this.m1n(), 'year');
  var dayOfYear = this.e1n_1;
  var tmp;
  if (dayOfYear == null) {
    tmp = new LocalDate(year, requireParsedField(this.r1n(), 'monthNumber'), requireParsedField(this.c1n_1, 'day'));
  } else {
    // Inline function 'kotlin.also' call
    var this_0 = plus_0(new LocalDate(year, 1, 1), dayOfYear - 1 | 0, Companion_getInstance_3().w1l_1);
    if (!(this_0.n1n_1 === year)) {
      throw DateTimeFormatException_init_$Create$_0('Can not create a LocalDate from the given input: ' + ('the day of year is ' + dayOfYear + ', which is not a valid day of year for the year ' + year));
    }
    if (!(this.r1n() == null) && !(get_number(this_0.q1n()) === this.r1n())) {
      throw DateTimeFormatException_init_$Create$_0('Can not create a LocalDate from the given input: ' + ('the day of year is ' + dayOfYear + ', which is ' + this_0.q1n().toString() + ', ') + ('but ' + this.r1n() + ' was specified as the month number'));
    }
    if (!(this.c1n_1 == null) && !(this_0.o1n_1 === this.c1n_1)) {
      throw DateTimeFormatException_init_$Create$_0('Can not create a LocalDate from the given input: ' + ('the day of year is ' + dayOfYear + ', which is the day ' + this_0.o1n_1 + ' of ' + this_0.q1n().toString() + ', ') + ('but ' + this.c1n_1 + ' was specified as the day of month'));
    }
    tmp = this_0;
  }
  var date = tmp;
  var tmp0_safe_receiver = this.d1n_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    if (!(tmp0_safe_receiver === get_isoDayNumber(date.i1n()))) {
      throw DateTimeFormatException_init_$Create$_0('Can not create a LocalDate from the given input: ' + ('the day of week is ' + DayOfWeek_0(tmp0_safe_receiver).toString() + ' but the date is ' + date.toString() + ', which is a ' + date.i1n().toString()));
    }
  }
  return date;
};
protoOf(IncompleteLocalDate).s1n = function (date) {
  this.t1n(date.n1n_1);
  this.u1n(get_number(date.q1n()));
  this.c1n_1 = date.o1n_1;
  this.d1n_1 = get_isoDayNumber(date.i1n());
  this.e1n_1 = date.k1n();
};
protoOf(IncompleteLocalDate).v1n = function () {
  return new IncompleteLocalDate(this.b1n_1.v1n(), this.c1n_1, this.d1n_1, this.e1n_1);
};
protoOf(IncompleteLocalDate).equals = function (other) {
  var tmp;
  var tmp_0;
  var tmp_1;
  var tmp_2;
  if (other instanceof IncompleteLocalDate) {
    tmp_2 = this.b1n_1.equals(other.b1n_1);
  } else {
    tmp_2 = false;
  }
  if (tmp_2) {
    tmp_1 = this.c1n_1 == other.c1n_1;
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    tmp_0 = this.d1n_1 == other.d1n_1;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = this.e1n_1 == other.e1n_1;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(IncompleteLocalDate).hashCode = function () {
  var tmp = imul(this.b1n_1.hashCode(), 29791);
  // Inline function 'kotlin.hashCode' call
  var tmp0_safe_receiver = this.c1n_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
  var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  var tmp_0 = tmp + imul(tmp$ret$0, 961) | 0;
  // Inline function 'kotlin.hashCode' call
  var tmp0_safe_receiver_0 = this.d1n_1;
  var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
  var tmp$ret$1 = tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0;
  var tmp_1 = tmp_0 + imul(tmp$ret$1, 31) | 0;
  // Inline function 'kotlin.hashCode' call
  var tmp0_safe_receiver_1 = this.e1n_1;
  var tmp1_elvis_lhs_1 = tmp0_safe_receiver_1 == null ? null : hashCode(tmp0_safe_receiver_1);
  return tmp_1 + (tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1) | 0;
};
protoOf(IncompleteLocalDate).toString = function () {
  var tmp;
  if (this.e1n_1 == null) {
    var tmp_0 = this.b1n_1.toString();
    var tmp0_elvis_lhs = this.c1n_1;
    var tmp_1 = toString(tmp0_elvis_lhs == null ? '??' : tmp0_elvis_lhs);
    var tmp1_elvis_lhs = this.d1n_1;
    tmp = tmp_0 + '-' + tmp_1 + ' (day of week is ' + toString(tmp1_elvis_lhs == null ? '??' : tmp1_elvis_lhs) + ')';
  } else if (this.c1n_1 == null && this.r1n() == null) {
    var tmp2_elvis_lhs = this.b1n_1.w1n_1;
    var tmp_2 = toString(tmp2_elvis_lhs == null ? '??' : tmp2_elvis_lhs);
    var tmp_3 = this.e1n_1;
    var tmp3_elvis_lhs = this.d1n_1;
    tmp = '(' + tmp_2 + ')-' + tmp_3 + ' (day of week is ' + toString(tmp3_elvis_lhs == null ? '??' : tmp3_elvis_lhs) + ')';
  } else {
    var tmp_4 = this.b1n_1.toString();
    var tmp4_elvis_lhs = this.c1n_1;
    var tmp_5 = toString(tmp4_elvis_lhs == null ? '??' : tmp4_elvis_lhs);
    var tmp5_elvis_lhs = this.d1n_1;
    tmp = tmp_4 + '-' + tmp_5 + ' (day of week is ' + toString(tmp5_elvis_lhs == null ? '??' : tmp5_elvis_lhs) + ', day of year is ' + this.e1n_1 + ')';
  }
  return tmp;
};
protoOf(IncompleteLocalDate).t1n = function (_set____db54di) {
  this.b1n_1.w1n_1 = _set____db54di;
};
protoOf(IncompleteLocalDate).m1n = function () {
  return this.b1n_1.w1n_1;
};
protoOf(IncompleteLocalDate).u1n = function (_set____db54di) {
  this.b1n_1.x1n_1 = _set____db54di;
};
protoOf(IncompleteLocalDate).r1n = function () {
  return this.b1n_1.x1n_1;
};
function Companion_4() {
}
protoOf(Companion_4).y1n = function (block) {
  var builder = new Builder(new AppendableFormatStructure());
  block(builder);
  return new LocalDateFormat(builder.z1m());
};
var Companion_instance_4;
function Companion_getInstance_4() {
  return Companion_instance_4;
}
function Builder(actualBuilder) {
  this.z1n_1 = actualBuilder;
}
protoOf(Builder).w1m = function () {
  return this.z1n_1;
};
protoOf(Builder).a1o = function (structure) {
  return this.z1n_1.y1m(structure);
};
function LocalDateFormat(actualFormat) {
  AbstractDateTimeFormat.call(this);
  this.c1o_1 = actualFormat;
}
protoOf(LocalDateFormat).f1m = function () {
  return this.c1o_1;
};
protoOf(LocalDateFormat).d1o = function (value) {
  // Inline function 'kotlin.apply' call
  var this_0 = new IncompleteLocalDate();
  this_0.s1n(value);
  return this_0;
};
protoOf(LocalDateFormat).g1m = function (value) {
  return this.d1o(value instanceof LocalDate ? value : THROW_CCE());
};
protoOf(LocalDateFormat).e1o = function (intermediate) {
  return intermediate.l1n();
};
protoOf(LocalDateFormat).h1m = function (intermediate) {
  return this.e1o(intermediate instanceof IncompleteLocalDate ? intermediate : THROW_CCE());
};
protoOf(LocalDateFormat).i1m = function () {
  return get_emptyIncompleteLocalDate();
};
function AbstractWithDateBuilder() {
}
function DayDirective(padding) {
  var tmp = DateFields_getInstance().f1o_1;
  // Inline function 'kotlinx.datetime.format.minDigits' call
  var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
  // Inline function 'kotlinx.datetime.format.spaces' call
  var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 2 : null;
  UnsignedIntFieldFormatDirective.call(this, tmp, tmp_0, tmp$ret$1);
  this.m1o_1 = padding;
}
protoOf(DayDirective).equals = function (other) {
  var tmp;
  if (other instanceof DayDirective) {
    tmp = this.m1o_1.equals(other.m1o_1);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(DayDirective).hashCode = function () {
  return this.m1o_1.hashCode();
};
function DateFieldContainer$_get_day_$ref_2ebhxx() {
  return function (p0) {
    return p0.g1n();
  };
}
function DateFieldContainer$_set_day_$ref_s0jsax() {
  return function (p0, p1) {
    p0.f1n(p1);
    return Unit_instance;
  };
}
function DateFieldContainer$_get_dayOfWeek_$ref_thwqom() {
  return function (p0) {
    return p0.i1n();
  };
}
function DateFieldContainer$_set_dayOfWeek_$ref_ea586a() {
  return function (p0, p1) {
    p0.h1n(p1);
    return Unit_instance;
  };
}
function DateFieldContainer$_get_dayOfYear_$ref_2m6gfz() {
  return function (p0) {
    return p0.k1n();
  };
}
function DateFieldContainer$_set_dayOfYear_$ref_cll22d() {
  return function (p0, p1) {
    p0.j1n(p1);
    return Unit_instance;
  };
}
function DateFields() {
  DateFields_instance = this;
  var tmp = this;
  var tmp_0 = KMutableProperty1;
  var tmp_1 = DateFieldContainer$_get_day_$ref_2ebhxx();
  tmp.f1o_1 = new UnsignedFieldSpec(new PropertyAccessor(getPropertyCallableRef('day', 1, tmp_0, tmp_1, DateFieldContainer$_set_day_$ref_s0jsax())), 1, 31);
  var tmp_2 = this;
  var tmp_3 = KMutableProperty1;
  var tmp_4 = DateFieldContainer$_get_dayOfWeek_$ref_thwqom();
  tmp_2.g1o_1 = new UnsignedFieldSpec(new PropertyAccessor(getPropertyCallableRef('dayOfWeek', 1, tmp_3, tmp_4, DateFieldContainer$_set_dayOfWeek_$ref_ea586a())), 1, 7);
  var tmp_5 = this;
  var tmp_6 = KMutableProperty1;
  var tmp_7 = DateFieldContainer$_get_dayOfYear_$ref_2m6gfz();
  tmp_5.h1o_1 = new UnsignedFieldSpec(new PropertyAccessor(getPropertyCallableRef('dayOfYear', 1, tmp_6, tmp_7, DateFieldContainer$_set_dayOfYear_$ref_cll22d())), 1, 366);
}
var DateFields_instance;
function DateFields_getInstance() {
  if (DateFields_instance == null)
    new DateFields();
  return DateFields_instance;
}
function ISO_DATE$delegate$lambda() {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  var tmp = Companion_instance_4;
  return tmp.y1n(ISO_DATE$delegate$lambda$lambda);
}
function ISO_DATE$delegate$lambda$lambda($this$build) {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  $this$build.q1m();
  char($this$build, _Char___init__impl__6a9atx(45));
  $this$build.s1m();
  char($this$build, _Char___init__impl__6a9atx(45));
  $this$build.v1m();
  return Unit_instance;
}
function _get_ISO_DATE_$ref_powsum() {
  return function () {
    return get_ISO_DATE();
  };
}
function ISO_DATE_BASIC$delegate$lambda() {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  var tmp = Companion_instance_4;
  return tmp.y1n(ISO_DATE_BASIC$delegate$lambda$lambda);
}
function ISO_DATE_BASIC$delegate$lambda$lambda($this$build) {
  _init_properties_LocalDateFormat_kt__k1uk9u();
  $this$build.q1m();
  $this$build.s1m();
  $this$build.v1m();
  return Unit_instance;
}
function _get_ISO_DATE_BASIC_$ref_3fs8eb() {
  return function () {
    return get_ISO_DATE_BASIC();
  };
}
var properties_initialized_LocalDateFormat_kt_fmnlhc;
function _init_properties_LocalDateFormat_kt__k1uk9u() {
  if (!properties_initialized_LocalDateFormat_kt_fmnlhc) {
    properties_initialized_LocalDateFormat_kt_fmnlhc = true;
    ISO_DATE$delegate = lazy(ISO_DATE$delegate$lambda);
    ISO_DATE_BASIC$delegate = lazy(ISO_DATE_BASIC$delegate$lambda);
    emptyIncompleteLocalDate = new IncompleteLocalDate();
  }
}
function get_emptyIncompleteYearMonth() {
  _init_properties_YearMonthFormat_kt__i0mmu0();
  return emptyIncompleteYearMonth;
}
var emptyIncompleteYearMonth;
function get_ISO_YEAR_MONTH() {
  _init_properties_YearMonthFormat_kt__i0mmu0();
  var tmp0 = ISO_YEAR_MONTH$delegate;
  var tmp = KProperty0;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('ISO_YEAR_MONTH', 0, tmp, _get_ISO_YEAR_MONTH_$ref_y3tv9a(), null);
  return tmp0.w();
}
var ISO_YEAR_MONTH$delegate;
function IncompleteYearMonth(year, monthNumber) {
  year = year === VOID ? null : year;
  monthNumber = monthNumber === VOID ? null : monthNumber;
  this.w1n_1 = year;
  this.x1n_1 = monthNumber;
}
protoOf(IncompleteYearMonth).t1n = function (_set____db54di) {
  this.w1n_1 = _set____db54di;
};
protoOf(IncompleteYearMonth).m1n = function () {
  return this.w1n_1;
};
protoOf(IncompleteYearMonth).u1n = function (_set____db54di) {
  this.x1n_1 = _set____db54di;
};
protoOf(IncompleteYearMonth).r1n = function () {
  return this.x1n_1;
};
protoOf(IncompleteYearMonth).r1o = function () {
  var year = requireParsedField(this.w1n_1, 'year');
  var month = requireParsedField(this.x1n_1, 'monthNumber');
  return new YearMonth(year, month);
};
protoOf(IncompleteYearMonth).s1o = function (yearMonth) {
  this.w1n_1 = yearMonth.t1o_1;
  this.x1n_1 = get_number(yearMonth.q1n());
};
protoOf(IncompleteYearMonth).v1n = function () {
  return new IncompleteYearMonth(this.w1n_1, this.x1n_1);
};
protoOf(IncompleteYearMonth).equals = function (other) {
  var tmp;
  var tmp_0;
  if (other instanceof IncompleteYearMonth) {
    tmp_0 = this.w1n_1 == other.w1n_1;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = this.x1n_1 == other.x1n_1;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(IncompleteYearMonth).hashCode = function () {
  // Inline function 'kotlin.hashCode' call
  var tmp0_safe_receiver = this.w1n_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
  var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  var tmp = imul(tmp$ret$0, 31);
  // Inline function 'kotlin.hashCode' call
  var tmp0_safe_receiver_0 = this.x1n_1;
  var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
  return tmp + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
};
protoOf(IncompleteYearMonth).toString = function () {
  var tmp0_elvis_lhs = this.w1n_1;
  var tmp = toString(tmp0_elvis_lhs == null ? '??' : tmp0_elvis_lhs);
  var tmp1_elvis_lhs = this.x1n_1;
  return tmp + '-' + toString(tmp1_elvis_lhs == null ? '??' : tmp1_elvis_lhs);
};
function requireParsedField(field, name) {
  _init_properties_YearMonthFormat_kt__i0mmu0();
  if (field == null) {
    throw DateTimeFormatException_init_$Create$_0('Can not create a ' + name + ' from the given input: the field ' + name + ' is missing');
  }
  return field;
}
function AbstractWithYearMonthBuilder() {
}
function Companion_5() {
}
protoOf(Companion_5).v1o = function (block) {
  var builder = new Builder_0(new AppendableFormatStructure());
  block(builder);
  return new YearMonthFormat(builder.z1m());
};
var Companion_instance_5;
function Companion_getInstance_5() {
  return Companion_instance_5;
}
function Builder_0(actualBuilder) {
  this.w1o_1 = actualBuilder;
}
protoOf(Builder_0).w1m = function () {
  return this.w1o_1;
};
protoOf(Builder_0).b1o = function (structure) {
  return this.w1o_1.y1m(structure);
};
function YearMonthFormat(actualFormat) {
  AbstractDateTimeFormat.call(this);
  this.x1o_1 = actualFormat;
}
protoOf(YearMonthFormat).f1m = function () {
  return this.x1o_1;
};
protoOf(YearMonthFormat).y1o = function (value) {
  // Inline function 'kotlin.apply' call
  var this_0 = new IncompleteYearMonth();
  this_0.s1o(value);
  return this_0;
};
protoOf(YearMonthFormat).g1m = function (value) {
  return this.y1o(value instanceof YearMonth ? value : THROW_CCE());
};
protoOf(YearMonthFormat).z1o = function (intermediate) {
  return intermediate.r1o();
};
protoOf(YearMonthFormat).h1m = function (intermediate) {
  return this.z1o(intermediate instanceof IncompleteYearMonth ? intermediate : THROW_CCE());
};
protoOf(YearMonthFormat).i1m = function () {
  return get_emptyIncompleteYearMonth();
};
function YearDirective(padding, isYearOfEra) {
  isYearOfEra = isYearOfEra === VOID ? false : isYearOfEra;
  var tmp = YearMonthFields_getInstance().a1p_1;
  // Inline function 'kotlinx.datetime.format.minDigits' call
  var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 4 : 1;
  // Inline function 'kotlinx.datetime.format.spaces' call
  var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 4 : null;
  SignedIntFieldFormatDirective.call(this, tmp, tmp_0, null, tmp$ret$1, 4);
  this.h1p_1 = padding;
  this.i1p_1 = isYearOfEra;
}
protoOf(YearDirective).equals = function (other) {
  var tmp;
  var tmp_0;
  if (other instanceof YearDirective) {
    tmp_0 = this.h1p_1.equals(other.h1p_1);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = this.i1p_1 === other.i1p_1;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(YearDirective).hashCode = function () {
  return imul(this.h1p_1.hashCode(), 31) + getBooleanHashCode(this.i1p_1) | 0;
};
function MonthDirective(padding) {
  var tmp = YearMonthFields_getInstance().b1p_1;
  // Inline function 'kotlinx.datetime.format.minDigits' call
  var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
  // Inline function 'kotlinx.datetime.format.spaces' call
  var tmp$ret$1 = padding.equals(Padding_SPACE_getInstance()) ? 2 : null;
  UnsignedIntFieldFormatDirective.call(this, tmp, tmp_0, tmp$ret$1);
  this.s1p_1 = padding;
}
protoOf(MonthDirective).equals = function (other) {
  var tmp;
  if (other instanceof MonthDirective) {
    tmp = this.s1p_1.equals(other.s1p_1);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(MonthDirective).hashCode = function () {
  return this.s1p_1.hashCode();
};
function YearMonthFieldContainer$_get_year_$ref_7j3zdj() {
  return function (p0) {
    return p0.m1n();
  };
}
function YearMonthFieldContainer$_set_year_$ref_kc0aub() {
  return function (p0, p1) {
    p0.t1n(p1);
    return Unit_instance;
  };
}
function YearMonthFieldContainer$_get_monthNumber_$ref_pn0wu5() {
  return function (p0) {
    return p0.r1n();
  };
}
function YearMonthFieldContainer$_set_monthNumber_$ref_fjapbl() {
  return function (p0, p1) {
    p0.u1n(p1);
    return Unit_instance;
  };
}
function YearMonthFields() {
  YearMonthFields_instance = this;
  var tmp = this;
  var tmp_0 = KMutableProperty1;
  var tmp_1 = YearMonthFieldContainer$_get_year_$ref_7j3zdj();
  tmp.a1p_1 = new GenericFieldSpec(new PropertyAccessor(getPropertyCallableRef('year', 1, tmp_0, tmp_1, YearMonthFieldContainer$_set_year_$ref_kc0aub())));
  var tmp_2 = this;
  var tmp_3 = KMutableProperty1;
  var tmp_4 = YearMonthFieldContainer$_get_monthNumber_$ref_pn0wu5();
  tmp_2.b1p_1 = new UnsignedFieldSpec(new PropertyAccessor(getPropertyCallableRef('monthNumber', 1, tmp_3, tmp_4, YearMonthFieldContainer$_set_monthNumber_$ref_fjapbl())), 1, 12);
}
var YearMonthFields_instance;
function YearMonthFields_getInstance() {
  if (YearMonthFields_instance == null)
    new YearMonthFields();
  return YearMonthFields_instance;
}
function ISO_YEAR_MONTH$delegate$lambda() {
  _init_properties_YearMonthFormat_kt__i0mmu0();
  var tmp = Companion_instance_5;
  return tmp.v1o(ISO_YEAR_MONTH$delegate$lambda$lambda);
}
function ISO_YEAR_MONTH$delegate$lambda$lambda($this$build) {
  _init_properties_YearMonthFormat_kt__i0mmu0();
  $this$build.q1m();
  char($this$build, _Char___init__impl__6a9atx(45));
  $this$build.s1m();
  return Unit_instance;
}
function _get_ISO_YEAR_MONTH_$ref_y3tv9a() {
  return function () {
    return get_ISO_YEAR_MONTH();
  };
}
var properties_initialized_YearMonthFormat_kt_fp0mk6;
function _init_properties_YearMonthFormat_kt__i0mmu0() {
  if (!properties_initialized_YearMonthFormat_kt_fp0mk6) {
    properties_initialized_YearMonthFormat_kt_fp0mk6 = true;
    emptyIncompleteYearMonth = new IncompleteYearMonth();
    ISO_YEAR_MONTH$delegate = lazy(ISO_YEAR_MONTH$delegate$lambda);
  }
}
function monthLength(_this__u8e3s4, isLeapYear) {
  switch (_this__u8e3s4) {
    case 2:
      return isLeapYear ? 29 : 28;
    case 4:
    case 6:
    case 9:
    case 11:
      return 30;
    default:
      return 31;
  }
}
function isLeapYear(year) {
  var prolepticYear = fromInt(year);
  var tmp;
  if ((prolepticYear & 3n) === 0n) {
    var tmp_0;
    // Inline function 'kotlin.Long.rem' call
    if (!(modulo(prolepticYear, fromInt(100)) === 0n)) {
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.Long.rem' call
      tmp_0 = modulo(prolepticYear, fromInt(400)) === 0n;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
}
function AppendableFormatStructure() {
  var tmp = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp.x1m_1 = ArrayList_init_$Create$();
}
protoOf(AppendableFormatStructure).z1m = function () {
  return new ConcatenatedFormatStructure(this.x1m_1);
};
protoOf(AppendableFormatStructure).y1m = function (format) {
  if (isInterface(format, NonConcatenatedFormatStructure))
    this.x1m_1.j(format);
  else {
    if (format instanceof ConcatenatedFormatStructure) {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = format.a1n_1.l();
      while (_iterator__ex2g4s.m()) {
        var element = _iterator__ex2g4s.n();
        this.x1m_1.j(element);
      }
    } else {
      noWhenBranchMatchedException();
    }
  }
};
function Accessor$getterNotNull$ref(p0) {
  var l = function (_this__u8e3s4) {
    return p0.t1p(_this__u8e3s4);
  };
  l.callableName = 'getterNotNull';
  return l;
}
function UnsignedIntFieldFormatDirective(field, minDigits, spacePadding) {
  this.n1o_1 = field;
  this.o1o_1 = minDigits;
  this.p1o_1 = spacePadding;
  this.q1o_1 = this.n1o_1.a1q_1;
  // Inline function 'kotlin.require' call
  if (!(this.o1o_1 >= 0)) {
    var message = 'The minimum number of digits (' + this.o1o_1 + ') is negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(this.q1o_1 >= this.o1o_1)) {
    var message_0 = 'The maximum number of digits (' + this.q1o_1 + ') is less than the minimum number of digits (' + this.o1o_1 + ')';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  if (!(this.p1o_1 == null)) {
    // Inline function 'kotlin.require' call
    if (!(this.p1o_1 > this.o1o_1)) {
      var message_1 = 'The space padding (' + this.p1o_1 + ') should be more than the minimum number of digits (' + this.o1o_1 + ')';
      throw IllegalArgumentException_init_$Create$(toString(message_1));
    }
  }
}
protoOf(UnsignedIntFieldFormatDirective).m1m = function () {
  var formatter = new UnsignedIntFormatterStructure(Accessor$getterNotNull$ref(this.n1o_1.u1p_1), this.o1o_1);
  return !(this.p1o_1 == null) ? new SpacePaddedFormatter(formatter, this.p1o_1) : formatter;
};
protoOf(UnsignedIntFieldFormatDirective).o1m = function () {
  return spaceAndZeroPaddedUnsignedInt(this.o1o_1, this.q1o_1, this.p1o_1, this.n1o_1.u1p_1, this.n1o_1.x1p_1);
};
function Accessor$getterNotNull$ref_0(p0) {
  var l = function (_this__u8e3s4) {
    return p0.t1p(_this__u8e3s4);
  };
  l.callableName = 'getterNotNull';
  return l;
}
function SignedIntFieldFormatDirective(field, minDigits, maxDigits, spacePadding, outputPlusOnExceededWidth) {
  this.j1p_1 = field;
  this.k1p_1 = minDigits;
  this.l1p_1 = maxDigits;
  this.m1p_1 = spacePadding;
  this.n1p_1 = outputPlusOnExceededWidth;
  // Inline function 'kotlin.require' call
  if (!(this.k1p_1 == null || this.k1p_1 >= 0)) {
    var message = 'The minimum number of digits (' + this.k1p_1 + ') is negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(this.l1p_1 == null || this.k1p_1 == null || this.l1p_1 >= this.k1p_1)) {
    var message_0 = 'The maximum number of digits (' + this.l1p_1 + ') is less than the minimum number of digits (' + this.k1p_1 + ')';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
}
protoOf(SignedIntFieldFormatDirective).m1m = function () {
  var tmp = Accessor$getterNotNull$ref_0(this.j1p_1.b1q());
  var tmp0_elvis_lhs = this.k1p_1;
  var formatter = new SignedIntFormatterStructure(tmp, tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs, this.n1p_1);
  return !(this.m1p_1 == null) ? new SpacePaddedFormatter(formatter, this.m1p_1) : formatter;
};
protoOf(SignedIntFieldFormatDirective).o1m = function () {
  return SignedIntParser(this.k1p_1, this.l1p_1, this.m1p_1, this.j1p_1.b1q(), this.j1p_1.k2(), this.n1p_1);
};
function GenericFieldSpec(accessor, name, defaultValue, sign) {
  name = name === VOID ? accessor.k2() : name;
  defaultValue = defaultValue === VOID ? null : defaultValue;
  sign = sign === VOID ? null : sign;
  AbstractFieldSpec.call(this);
  this.c1q_1 = accessor;
  this.d1q_1 = name;
  this.e1q_1 = defaultValue;
  this.f1q_1 = sign;
}
protoOf(GenericFieldSpec).b1q = function () {
  return this.c1q_1;
};
protoOf(GenericFieldSpec).k2 = function () {
  return this.d1q_1;
};
protoOf(GenericFieldSpec).g1q = function () {
  return this.e1q_1;
};
function PropertyAccessor(property, name) {
  name = name === VOID ? property.callableName : name;
  this.h1q_1 = property;
  this.i1q_1 = name;
}
protoOf(PropertyAccessor).k2 = function () {
  return this.i1q_1;
};
protoOf(PropertyAccessor).j1q = function (container, newValue) {
  var oldValue = this.h1q_1.get(container);
  var tmp;
  if (oldValue === null) {
    this.h1q_1.set(container, newValue);
    tmp = null;
  } else if (equals(oldValue, newValue)) {
    tmp = null;
  } else {
    tmp = oldValue;
  }
  return tmp;
};
protoOf(PropertyAccessor).k1q = function (container, newValue) {
  var tmp = (container == null ? true : !(container == null)) ? container : THROW_CCE();
  return this.j1q(tmp, (newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
};
protoOf(PropertyAccessor).l1q = function (container) {
  return this.h1q_1.get(container);
};
function UnsignedFieldSpec(accessor, minValue, maxValue, name, defaultValue, sign) {
  name = name === VOID ? accessor.k2() : name;
  defaultValue = defaultValue === VOID ? null : defaultValue;
  sign = sign === VOID ? null : sign;
  AbstractFieldSpec.call(this);
  this.u1p_1 = accessor;
  this.v1p_1 = minValue;
  this.w1p_1 = maxValue;
  this.x1p_1 = name;
  this.y1p_1 = defaultValue;
  this.z1p_1 = sign;
  var tmp = this;
  var tmp_0;
  if (this.w1p_1 < 10) {
    tmp_0 = 1;
  } else if (this.w1p_1 < 100) {
    tmp_0 = 2;
  } else if (this.w1p_1 < 1000) {
    tmp_0 = 3;
  } else {
    throw IllegalArgumentException_init_$Create$('Max value ' + this.w1p_1 + ' is too large');
  }
  tmp.a1q_1 = tmp_0;
}
protoOf(UnsignedFieldSpec).b1q = function () {
  return this.u1p_1;
};
protoOf(UnsignedFieldSpec).k2 = function () {
  return this.x1p_1;
};
protoOf(UnsignedFieldSpec).g1q = function () {
  return this.y1p_1;
};
function Accessor() {
}
function AbstractFieldSpec() {
}
protoOf(AbstractFieldSpec).toString = function () {
  return 'The field ' + this.k2() + ' (default value is ' + toString_1(this.g1q()) + ')';
};
function CachedFormatStructure(formats) {
  ConcatenatedFormatStructure.call(this, formats);
  this.k1m_1 = protoOf(ConcatenatedFormatStructure).m1m.call(this);
  this.l1m_1 = protoOf(ConcatenatedFormatStructure).o1m.call(this);
}
protoOf(CachedFormatStructure).m1m = function () {
  return this.k1m_1;
};
protoOf(CachedFormatStructure).o1m = function () {
  return this.l1m_1;
};
function BasicFormatStructure(directive) {
  this.m1q_1 = directive;
}
protoOf(BasicFormatStructure).toString = function () {
  return 'BasicFormatStructure(' + toString(this.m1q_1) + ')';
};
protoOf(BasicFormatStructure).equals = function (other) {
  var tmp;
  if (other instanceof BasicFormatStructure) {
    tmp = equals(this.m1q_1, other.m1q_1);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(BasicFormatStructure).hashCode = function () {
  return hashCode(this.m1q_1);
};
protoOf(BasicFormatStructure).o1m = function () {
  return this.m1q_1.o1m();
};
protoOf(BasicFormatStructure).m1m = function () {
  return this.m1q_1.m1m();
};
function ConstantFormatStructure(string) {
  this.n1q_1 = string;
}
protoOf(ConstantFormatStructure).toString = function () {
  return 'ConstantFormatStructure(' + this.n1q_1 + ')';
};
protoOf(ConstantFormatStructure).equals = function (other) {
  var tmp;
  if (other instanceof ConstantFormatStructure) {
    tmp = this.n1q_1 === other.n1q_1;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(ConstantFormatStructure).hashCode = function () {
  return getStringHashCode(this.n1q_1);
};
protoOf(ConstantFormatStructure).o1m = function () {
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  var this_0 = this.n1q_1;
  if (charSequenceLength(this_0) === 0) {
    tmp = emptyList();
  } else {
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_1 = ArrayList_init_$Create$();
    var tmp_0;
    if (isAsciiDigit(charCodeAt(this.n1q_1, 0))) {
      var tmp0 = this.n1q_1;
      var tmp$ret$2;
      $l$block: {
        // Inline function 'kotlin.text.takeWhile' call
        var inductionVariable = 0;
        var last = tmp0.length;
        if (inductionVariable < last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var it = charCodeAt(tmp0, index);
            if (!isAsciiDigit(it)) {
              tmp$ret$2 = substring(tmp0, 0, index);
              break $l$block;
            }
          }
           while (inductionVariable < last);
        tmp$ret$2 = tmp0;
      }
      this_1.j(new NumberSpanParserOperation(listOf(new ConstantNumberConsumer(tmp$ret$2))));
      var tmp0_0 = this.n1q_1;
      var tmp$ret$4;
      $l$block_0: {
        // Inline function 'kotlin.text.dropWhile' call
        var inductionVariable_0 = 0;
        var last_0 = charSequenceLength(tmp0_0) - 1 | 0;
        if (inductionVariable_0 <= last_0)
          do {
            var index_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var it_0 = charCodeAt(tmp0_0, index_0);
            if (!isAsciiDigit(it_0)) {
              tmp$ret$4 = substring_0(tmp0_0, index_0);
              break $l$block_0;
            }
          }
           while (inductionVariable_0 <= last_0);
        tmp$ret$4 = '';
      }
      tmp_0 = tmp$ret$4;
    } else {
      tmp_0 = this.n1q_1;
    }
    var suffix = tmp_0;
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(suffix) > 0) {
      if (isAsciiDigit(charCodeAt(suffix, suffix.length - 1 | 0))) {
        var tmp$ret$7;
        $l$block_1: {
          // Inline function 'kotlin.text.dropLastWhile' call
          var inductionVariable_1 = get_lastIndex(suffix);
          if (0 <= inductionVariable_1)
            do {
              var index_1 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + -1 | 0;
              var it_1 = charCodeAt(suffix, index_1);
              if (!isAsciiDigit(it_1)) {
                tmp$ret$7 = substring(suffix, 0, index_1 + 1 | 0);
                break $l$block_1;
              }
            }
             while (0 <= inductionVariable_1);
          tmp$ret$7 = '';
        }
        this_1.j(new PlainStringParserOperation(tmp$ret$7));
        var tmp$ret$9;
        $l$block_2: {
          // Inline function 'kotlin.text.takeLastWhile' call
          var inductionVariable_2 = get_lastIndex(suffix);
          if (0 <= inductionVariable_2)
            do {
              var index_2 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + -1 | 0;
              var it_2 = charCodeAt(suffix, index_2);
              if (!isAsciiDigit(it_2)) {
                tmp$ret$9 = substring_0(suffix, index_2 + 1 | 0);
                break $l$block_2;
              }
            }
             while (0 <= inductionVariable_2);
          tmp$ret$9 = suffix;
        }
        this_1.j(new NumberSpanParserOperation(listOf(new ConstantNumberConsumer(tmp$ret$9))));
      } else {
        this_1.j(new PlainStringParserOperation(suffix));
      }
    }
    tmp = this_1.u2();
  }
  return new ParserStructure(tmp, emptyList());
};
protoOf(ConstantFormatStructure).m1m = function () {
  return new ConstantStringFormatterStructure(this.n1q_1);
};
function ConcatenatedFormatStructure(formats) {
  this.a1n_1 = formats;
}
protoOf(ConcatenatedFormatStructure).toString = function () {
  return 'ConcatenatedFormatStructure(' + joinToString(this.a1n_1, ', ') + ')';
};
protoOf(ConcatenatedFormatStructure).equals = function (other) {
  var tmp;
  if (other instanceof ConcatenatedFormatStructure) {
    tmp = equals(this.a1n_1, other.a1n_1);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(ConcatenatedFormatStructure).hashCode = function () {
  return hashCode(this.a1n_1);
};
protoOf(ConcatenatedFormatStructure).o1m = function () {
  // Inline function 'kotlin.collections.map' call
  var this_0 = this.a1n_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.l();
  while (_iterator__ex2g4s.m()) {
    var item = _iterator__ex2g4s.n();
    var tmp$ret$0 = item.o1m();
    destination.j(tmp$ret$0);
  }
  return concat(destination);
};
protoOf(ConcatenatedFormatStructure).m1m = function () {
  // Inline function 'kotlin.collections.map' call
  var this_0 = this.a1n_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.l();
  while (_iterator__ex2g4s.m()) {
    var item = _iterator__ex2g4s.n();
    var tmp$ret$0 = item.m1m();
    destination.j(tmp$ret$0);
  }
  var formatters = destination;
  var tmp;
  if (formatters.o() === 1) {
    tmp = single(formatters);
  } else {
    tmp = new ConcatenatedFormatter(formatters);
  }
  return tmp;
};
function NonConcatenatedFormatStructure() {
}
function FormatterStructure() {
}
function SpacePaddedFormatter(formatter, padding) {
  this.p1q_1 = formatter;
  this.q1q_1 = padding;
}
protoOf(SpacePaddedFormatter).o1q = function (obj, builder, minusNotRequired) {
  // Inline function 'kotlin.let' call
  var it = StringBuilder_init_$Create$();
  this.p1q_1.o1q(obj, it, minusNotRequired);
  var string = it.toString();
  // Inline function 'kotlin.repeat' call
  var times = this.q1q_1 - string.length | 0;
  var inductionVariable = 0;
  if (inductionVariable < times)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      builder.l7(_Char___init__impl__6a9atx(32));
    }
     while (inductionVariable < times);
  builder.k(string);
};
function ConcatenatedFormatter(formatters) {
  this.r1q_1 = formatters;
}
protoOf(ConcatenatedFormatter).o1q = function (obj, builder, minusNotRequired) {
  var _iterator__ex2g4s = this.r1q_1.l();
  while (_iterator__ex2g4s.m()) {
    var formatter = _iterator__ex2g4s.n();
    formatter.o1q(obj, builder, minusNotRequired);
  }
};
function UnsignedIntFormatterStructure(number, zeroPadding) {
  this.s1q_1 = number;
  this.t1q_1 = zeroPadding;
  // Inline function 'kotlin.require' call
  if (!(this.t1q_1 >= 0)) {
    var message = 'The minimum number of digits (' + this.t1q_1 + ') is negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(this.t1q_1 <= 9)) {
    var message_0 = 'The minimum number of digits (' + this.t1q_1 + ') exceeds the length of an Int';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
}
protoOf(UnsignedIntFormatterStructure).o1q = function (obj, builder, minusNotRequired) {
  var num = this.s1q_1(obj);
  var numberStr = num.toString();
  // Inline function 'kotlin.repeat' call
  var times = this.t1q_1 - numberStr.length | 0;
  var inductionVariable = 0;
  if (inductionVariable < times)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      builder.l7(_Char___init__impl__6a9atx(48));
    }
     while (inductionVariable < times);
  builder.k(numberStr);
};
function SignedIntFormatterStructure(number, zeroPadding, outputPlusOnExceededWidth) {
  this.u1q_1 = number;
  this.v1q_1 = zeroPadding;
  this.w1q_1 = outputPlusOnExceededWidth;
  // Inline function 'kotlin.require' call
  if (!(this.v1q_1 >= 0)) {
    var message = 'The minimum number of digits (' + this.v1q_1 + ') is negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(this.v1q_1 <= 9)) {
    var message_0 = 'The minimum number of digits (' + this.v1q_1 + ') exceeds the length of an Int';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
}
protoOf(SignedIntFormatterStructure).o1q = function (obj, builder, minusNotRequired) {
  var innerBuilder = StringBuilder_init_$Create$();
  // Inline function 'kotlin.let' call
  var it = this.u1q_1(obj);
  var number = minusNotRequired && it < 0 ? -it | 0 : it;
  if (!(this.w1q_1 == null) && number >= get_POWERS_OF_TEN()[this.w1q_1]) {
    innerBuilder.l7(_Char___init__impl__6a9atx(43));
  }
  // Inline function 'kotlin.math.absoluteValue' call
  if (abs(number) < get_POWERS_OF_TEN()[this.v1q_1 - 1 | 0]) {
    if (number >= 0) {
      innerBuilder.yb(number + get_POWERS_OF_TEN()[this.v1q_1] | 0).ec(0);
    } else {
      innerBuilder.yb(number - get_POWERS_OF_TEN()[this.v1q_1] | 0).ec(1);
    }
  } else {
    innerBuilder.yb(number);
  }
  builder.k(innerBuilder);
};
function ConstantStringFormatterStructure(string) {
  this.x1q_1 = string;
}
protoOf(ConstantStringFormatterStructure).o1q = function (obj, builder, minusNotRequired) {
  builder.k(this.x1q_1);
};
function ConstantNumberConsumer(expected) {
  NumberConsumer.call(this, expected.length, 'the predefined string ' + expected);
  this.a1r_1 = expected;
}
protoOf(ConstantNumberConsumer).b1r = function (storage, input, start, end) {
  var tmp;
  // Inline function 'kotlin.text.substring' call
  if (toString(charSequenceSubSequence(input, start, end)) === this.a1r_1) {
    tmp = null;
  } else {
    tmp = new WrongConstant(this.a1r_1);
  }
  return tmp;
};
function NumberConsumer(length, whatThisExpects) {
  this.c1r_1 = length;
  this.d1r_1 = whatThisExpects;
}
protoOf(NumberConsumer).a = function () {
  return this.c1r_1;
};
function ExpectedInt() {
}
protoOf(ExpectedInt).e1r = function () {
  return 'expected an Int value';
};
var ExpectedInt_instance;
function ExpectedInt_getInstance() {
  return ExpectedInt_instance;
}
function TooManyDigits(maxDigits) {
  this.f1r_1 = maxDigits;
}
protoOf(TooManyDigits).e1r = function () {
  return 'expected at most ' + this.f1r_1 + ' digits';
};
function TooFewDigits(minDigits) {
  this.g1r_1 = minDigits;
}
protoOf(TooFewDigits).e1r = function () {
  return 'expected at least ' + this.g1r_1 + ' digits';
};
function WrongConstant(expected) {
  this.h1r_1 = expected;
}
protoOf(WrongConstant).e1r = function () {
  return "expected '" + this.h1r_1 + "'";
};
function Conflicting(conflicting) {
  this.i1r_1 = conflicting;
}
protoOf(Conflicting).e1r = function () {
  return "attempted to overwrite the existing value '" + toString(this.i1r_1) + "'";
};
function setWithoutReassigning(_this__u8e3s4, receiver, value) {
  var tmp0_elvis_lhs = _this__u8e3s4.k1q(receiver, value);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var conflictingValue = tmp;
  return new Conflicting(conflictingValue);
}
function UnsignedIntConsumer(minLength, maxLength, setter, name, multiplyByMinus1) {
  multiplyByMinus1 = multiplyByMinus1 === VOID ? false : multiplyByMinus1;
  NumberConsumer.call(this, minLength == maxLength ? minLength : null, name);
  this.l1r_1 = minLength;
  this.m1r_1 = maxLength;
  this.n1r_1 = setter;
  this.o1r_1 = multiplyByMinus1;
  // Inline function 'kotlin.require' call
  if (!(this.a() == null || numberRangeToNumber(1, 9).dj(this.a()))) {
    var message = 'Invalid length for field ' + this.d1r_1 + ': ' + this.a();
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
}
protoOf(UnsignedIntConsumer).b1r = function (storage, input, start, end) {
  var tmp;
  if (!(this.m1r_1 == null) && (end - start | 0) > this.m1r_1) {
    tmp = new TooManyDigits(this.m1r_1);
  } else if (!(this.l1r_1 == null) && (end - start | 0) < this.l1r_1) {
    tmp = new TooFewDigits(this.l1r_1);
  } else {
    var result = parseAsciiIntOrNull(input, start, end);
    tmp = result == null ? ExpectedInt_instance : setWithoutReassigning(this.n1r_1, storage, this.o1r_1 ? -result | 0 : result);
  }
  return tmp;
};
function parseAsciiIntOrNull(_this__u8e3s4, start, end) {
  var result = 0;
  var inductionVariable = start;
  if (inductionVariable < end)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var digit = charSequenceGet(_this__u8e3s4, i);
      result = imul(result, 10) + asciiDigitToInt(digit) | 0;
      if (result < 0)
        return null;
    }
     while (inductionVariable < end);
  return result;
}
function ParseError(position, message) {
  this.p1r_1 = position;
  this.q1r_1 = message;
}
function _ParseResult___init__impl__gvz3cn(value) {
  return value;
}
function _ParseResult___get_value__impl__86mnxf($this) {
  return $this;
}
function Companion_6() {
}
protoOf(Companion_6).r1r = function (indexOfNextUnparsed) {
  return _ParseResult___init__impl__gvz3cn(indexOfNextUnparsed);
};
protoOf(Companion_6).s1r = function (position, message) {
  return _ParseResult___init__impl__gvz3cn(new ParseError(position, message));
};
var Companion_instance_6;
function Companion_getInstance_6() {
  return Companion_instance_6;
}
function _Parser___init__impl__gdyfby(commands) {
  return commands;
}
function _get_commands__a20n1($this) {
  return $this;
}
function Parser__match_impl_nzt83d($this, input, initialContainer, startIndex) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var errors = ArrayList_init_$Create$();
  // Inline function 'kotlinx.datetime.internal.format.parser.Parser.parse' call
  var parseOptions = mutableListOf([new ParserState(initialContainer, _get_commands__a20n1($this), startIndex)]);
  iterate_over_alternatives: while (true) {
    var tmp0_elvis_lhs = removeLastOrNull(parseOptions);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      break iterate_over_alternatives;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var state = tmp;
    var output = state.t1r_1.v1n();
    var inputPosition = state.v1r_1;
    var parserStructure = state.u1r_1;
    // Inline function 'kotlin.run' call
    $l$block: {
      var inductionVariable = 0;
      var last = parserStructure.x1r_1.o() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var ix = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlinx.datetime.internal.format.parser.ParseResult.match' call
          var this_0 = parserStructure.x1r_1.p(ix).z1r(output, input, inputPosition);
          var tmp0_subject = _ParseResult___get_value__impl__86mnxf(this_0);
          if (typeof tmp0_subject === 'number') {
            inputPosition = _ParseResult___get_value__impl__86mnxf(this_0);
          } else {
            if (tmp0_subject instanceof ParseError) {
              var it = _ParseResult___get_value__impl__86mnxf(this_0);
              errors.j(it);
              break $l$block;
            } else {
              // Inline function 'kotlin.error' call
              var message = 'Unexpected parse result: ' + toString(_ParseResult___get_value__impl__86mnxf(this_0));
              throw IllegalStateException_init_$Create$(toString(message));
            }
          }
        }
         while (inductionVariable <= last);
      if (parserStructure.y1r_1.q()) {
        if (false || inputPosition === charSequenceLength(input)) {
          return output;
        } else {
          var tmp_0 = inputPosition;
          var it_0 = new ParseError(tmp_0, Parser$match$lambda);
          errors.j(it_0);
        }
      } else {
        var inductionVariable_0 = parserStructure.y1r_1.o() - 1 | 0;
        if (0 <= inductionVariable_0)
          do {
            var ix_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + -1 | 0;
            parseOptions.j(new ParserState(output, parserStructure.y1r_1.p(ix_0), inputPosition));
          }
           while (0 <= inductionVariable_0);
      }
    }
  }
  // Inline function 'kotlin.collections.sortByDescending' call
  if (errors.o() > 1) {
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp_1 = Parser$match$lambda_0;
    var tmp$ret$8 = new sam$kotlin_Comparator$0(tmp_1);
    sortWith(errors, tmp$ret$8);
  }
  throw new ParseException(errors);
}
function Parser__match$default_impl_x2xlti($this, input, initialContainer, startIndex, $super) {
  startIndex = startIndex === VOID ? 0 : startIndex;
  var tmp;
  if ($super === VOID) {
    tmp = Parser__match_impl_nzt83d($this, input, initialContainer, startIndex);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new Parser(tmp_0)).a1s.call(new Parser($this), input, initialContainer, startIndex);
  }
  return tmp;
}
function ParserState(output, parserStructure, inputPosition) {
  this.t1r_1 = output;
  this.u1r_1 = parserStructure;
  this.v1r_1 = inputPosition;
}
function Parser__toString_impl_x33iea($this) {
  return 'Parser(commands=' + $this.toString() + ')';
}
function Parser__hashCode_impl_bbxllf($this) {
  return hashCode($this);
}
function Parser__equals_impl_djxokv($this, other) {
  if (!(other instanceof Parser))
    return false;
  var tmp0_other_with_cast = other instanceof Parser ? other.w1r_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function sam$kotlin_Comparator$0(function_0) {
  this.b1s_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0).od = function (a, b) {
  return this.b1s_1(a, b);
};
protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
  return this.od(a, b);
};
protoOf(sam$kotlin_Comparator$0).r2 = function () {
  return this.b1s_1;
};
protoOf(sam$kotlin_Comparator$0).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.r2(), other.r2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0).hashCode = function () {
  return hashCode(this.r2());
};
function Parser$match$lambda() {
  return 'There is more input to consume';
}
function Parser$match$lambda_0(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.p1r_1;
  var tmp$ret$1 = a.p1r_1;
  return compareValues(tmp, tmp$ret$1);
}
function Parser(commands) {
  this.w1r_1 = commands;
}
protoOf(Parser).toString = function () {
  return Parser__toString_impl_x33iea(this.w1r_1);
};
protoOf(Parser).hashCode = function () {
  return Parser__hashCode_impl_bbxllf(this.w1r_1);
};
protoOf(Parser).equals = function (other) {
  return Parser__equals_impl_djxokv(this.w1r_1, other);
};
function ParserStructure(operations, followedBy) {
  this.x1r_1 = operations;
  this.y1r_1 = followedBy;
}
protoOf(ParserStructure).toString = function () {
  return joinToString(this.x1r_1, ', ') + '(' + joinToString(this.y1r_1, ';') + ')';
};
function ParseException(errors) {
  Exception_init_$Init$(formatError(errors), this);
  captureStack(this, ParseException);
}
function concat(_this__u8e3s4) {
  // Inline function 'kotlin.collections.foldRight' call
  var accumulator = new ParserStructure(emptyList(), emptyList());
  if (!_this__u8e3s4.q()) {
    var iterator = _this__u8e3s4.r(_this__u8e3s4.o());
    while (iterator.u3()) {
      var tmp0 = iterator.w3();
      var acc = accumulator;
      accumulator = concat$append(tmp0, acc);
    }
  }
  var naiveParser = accumulator;
  return concat$simplify(naiveParser, emptyList());
}
function formatError(errors) {
  if (errors.o() === 1) {
    return 'Position ' + errors.p(0).p1r_1 + ': ' + errors.p(0).q1r_1();
  }
  var averageMessageLength = 33;
  var tmp0_buffer = StringBuilder_init_$Create$_0(imul(averageMessageLength, errors.o()));
  return joinTo(errors, tmp0_buffer, ', ', 'Errors: ', VOID, VOID, VOID, formatError$lambda).toString();
}
function concat$append(_this__u8e3s4, other) {
  var tmp;
  if (_this__u8e3s4.y1r_1.q()) {
    tmp = new ParserStructure(plus(_this__u8e3s4.x1r_1, other.x1r_1), other.y1r_1);
  } else {
    // Inline function 'kotlin.collections.map' call
    var this_0 = _this__u8e3s4.y1r_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.l();
    while (_iterator__ex2g4s.m()) {
      var item = _iterator__ex2g4s.n();
      var tmp$ret$0 = concat$append(item, other);
      destination.j(tmp$ret$0);
    }
    tmp = new ParserStructure(_this__u8e3s4.x1r_1, destination);
  }
  return tmp;
}
function concat$simplify(_this__u8e3s4, unconditionalModifications) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var newOperations = ArrayList_init_$Create$();
  var currentNumberSpan = null;
  var unconditionalModificationsForTails = toMutableList(unconditionalModifications);
  var _iterator__ex2g4s = _this__u8e3s4.x1r_1.l();
  while (_iterator__ex2g4s.m()) {
    var op = _iterator__ex2g4s.n();
    if (op instanceof NumberSpanParserOperation) {
      if (!(currentNumberSpan == null)) {
        currentNumberSpan.s(op.c1s_1);
      } else {
        currentNumberSpan = toMutableList(op.c1s_1);
      }
    } else {
      if (op instanceof UnconditionalModification) {
        unconditionalModificationsForTails.j(op);
      } else {
        if (!(currentNumberSpan == null)) {
          newOperations.j(new NumberSpanParserOperation(currentNumberSpan));
          currentNumberSpan = null;
        }
        newOperations.j(op);
      }
    }
  }
  // Inline function 'kotlin.collections.flatMap' call
  var tmp0 = _this__u8e3s4.y1r_1;
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList_init_$Create$();
  var _iterator__ex2g4s_0 = tmp0.l();
  while (_iterator__ex2g4s_0.m()) {
    var element = _iterator__ex2g4s_0.n();
    var simplified = concat$simplify(element, unconditionalModificationsForTails);
    var tmp;
    if (simplified.x1r_1.q()) {
      // Inline function 'kotlin.collections.ifEmpty' call
      var this_0 = simplified.y1r_1;
      var tmp_0;
      if (this_0.q()) {
        tmp_0 = listOf(simplified);
      } else {
        tmp_0 = this_0;
      }
      tmp = tmp_0;
    } else {
      tmp = listOf(simplified);
    }
    var list = tmp;
    addAll(destination, list);
  }
  // Inline function 'kotlin.collections.ifEmpty' call
  var tmp_1;
  if (destination.q()) {
    tmp_1 = listOf(new ParserStructure(unconditionalModificationsForTails, emptyList()));
  } else {
    tmp_1 = destination;
  }
  var mergedTails = tmp_1;
  var tmp_2;
  if (currentNumberSpan == null) {
    tmp_2 = new ParserStructure(newOperations, mergedTails);
  } else {
    var tmp$ret$8;
    $l$block_0: {
      // Inline function 'kotlin.collections.none' call
      var tmp_3;
      if (isInterface(mergedTails, Collection)) {
        tmp_3 = mergedTails.q();
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp$ret$8 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s_1 = mergedTails.l();
      while (_iterator__ex2g4s_1.m()) {
        var element_0 = _iterator__ex2g4s_1.n();
        var tmp0_safe_receiver = firstOrNull(element_0.x1r_1);
        var tmp_4;
        if (tmp0_safe_receiver == null) {
          tmp_4 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_4 = tmp0_safe_receiver instanceof NumberSpanParserOperation;
        }
        if (tmp_4 === true) {
          tmp$ret$8 = false;
          break $l$block_0;
        }
      }
      tmp$ret$8 = true;
    }
    if (tmp$ret$8) {
      newOperations.j(new NumberSpanParserOperation(currentNumberSpan));
      tmp_2 = new ParserStructure(newOperations, mergedTails);
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(mergedTails, 10));
      var _iterator__ex2g4s_2 = mergedTails.l();
      while (_iterator__ex2g4s_2.m()) {
        var item = _iterator__ex2g4s_2.n();
        var firstOperation = firstOrNull(item.x1r_1);
        var tmp_5;
        if (firstOperation instanceof NumberSpanParserOperation) {
          tmp_5 = new ParserStructure(plus(listOf(new NumberSpanParserOperation(plus(currentNumberSpan, firstOperation.c1s_1))), drop(item.x1r_1, 1)), item.y1r_1);
        } else {
          if (firstOperation == null) {
            tmp_5 = new ParserStructure(listOf(new NumberSpanParserOperation(currentNumberSpan)), item.y1r_1);
          } else {
            tmp_5 = new ParserStructure(plus(listOf(new NumberSpanParserOperation(currentNumberSpan)), item.x1r_1), item.y1r_1);
          }
        }
        var tmp$ret$12 = tmp_5;
        destination_0.j(tmp$ret$12);
      }
      var newTails = destination_0;
      tmp_2 = new ParserStructure(newOperations, newTails);
    }
  }
  return tmp_2;
}
function formatError$lambda(it) {
  return 'position ' + it.p1r_1 + ": '" + it.q1r_1() + "'";
}
function spaceAndZeroPaddedUnsignedInt(minDigits, maxDigits, spacePadding, setter, name, withMinus) {
  withMinus = withMinus === VOID ? false : withMinus;
  var minNumberLength = (minDigits == null ? 1 : minDigits) + (withMinus ? 1 : 0) | 0;
  var tmp;
  if (maxDigits == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = withMinus ? maxDigits + 1 | 0 : maxDigits;
  }
  var tmp2_elvis_lhs = tmp;
  var maxNumberLength = tmp2_elvis_lhs == null ? 2147483647 : tmp2_elvis_lhs;
  var spacePadding_0 = spacePadding == null ? 0 : spacePadding;
  // Inline function 'kotlin.comparisons.minOf' call
  var maxPaddedNumberLength = Math.min(maxNumberLength, spacePadding_0);
  if (minNumberLength >= maxPaddedNumberLength)
    return spaceAndZeroPaddedUnsignedInt$numberOfRequiredLengths(withMinus, setter, name, minNumberLength, maxNumberLength);
  var accumulated = spaceAndZeroPaddedUnsignedInt$numberOfRequiredLengths(withMinus, setter, name, minNumberLength, minNumberLength);
  var inductionVariable = minNumberLength;
  if (inductionVariable < maxPaddedNumberLength)
    do {
      var accumulatedWidth = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      accumulated = new ParserStructure(emptyList(), listOf_0([spaceAndZeroPaddedUnsignedInt$numberOfRequiredLengths(withMinus, setter, name, accumulatedWidth + 1 | 0, accumulatedWidth + 1 | 0), concat(listOf_0([new ParserStructure(listOf(new PlainStringParserOperation(' ')), emptyList()), accumulated]))]));
    }
     while (inductionVariable < maxPaddedNumberLength);
  var tmp_0;
  if (spacePadding_0 > maxNumberLength) {
    var prepadding = new PlainStringParserOperation(repeat(' ', spacePadding_0 - maxNumberLength | 0));
    tmp_0 = concat(listOf_0([new ParserStructure(listOf(prepadding), emptyList()), accumulated]));
  } else if (spacePadding_0 === maxNumberLength) {
    tmp_0 = accumulated;
  } else {
    var r = new ParserStructure(emptyList(), listOf_0([spaceAndZeroPaddedUnsignedInt$numberOfRequiredLengths(withMinus, setter, name, spacePadding_0 + 1 | 0, maxNumberLength), accumulated]));
    tmp_0 = r;
  }
  return tmp_0;
}
function _get_whatThisExpects__4pg11j($this) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = $this.c1s_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.l();
  while (_iterator__ex2g4s.m()) {
    var item = _iterator__ex2g4s.n();
    var length = item.a();
    var tmp$ret$0 = (length == null ? 'at least one digit' : '' + length + ' digits') + (' for ' + item.d1r_1);
    destination.j(tmp$ret$0);
  }
  var consumerLengths = destination;
  var tmp;
  if ($this.e1s_1) {
    tmp = 'a number with at least ' + $this.d1s_1 + ' digits: ' + toString(consumerLengths);
  } else {
    tmp = 'a number with exactly ' + $this.d1s_1 + ' digits: ' + toString(consumerLengths);
  }
  return tmp;
}
function NumberSpanParserOperation$consume$lambda(this$0) {
  return function () {
    return 'Unexpected end of input: yet to parse ' + _get_whatThisExpects__4pg11j(this$0);
  };
}
function NumberSpanParserOperation$consume$lambda_0($digitsInRow, this$0) {
  return function () {
    return 'Only found ' + $digitsInRow._v + ' digits in a row, but need to parse ' + _get_whatThisExpects__4pg11j(this$0);
  };
}
function NumberSpanParserOperation$consume$lambda_1($numberString, this$0, $i, $error) {
  return function () {
    return "Can not interpret the string '" + $numberString + "' as " + this$0.c1s_1.p($i).d1r_1 + ': ' + $error.e1r();
  };
}
function NumberSpanParserOperation(consumers) {
  this.c1s_1 = consumers;
  var tmp = this;
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var _iterator__ex2g4s = this.c1s_1.l();
  while (_iterator__ex2g4s.m()) {
    var element = _iterator__ex2g4s.n();
    var tmp_0 = sum;
    var tmp0_elvis_lhs = element.a();
    sum = tmp_0 + (tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs) | 0;
  }
  tmp.d1s_1 = sum;
  var tmp_1 = this;
  var tmp0 = this.c1s_1;
  var tmp$ret$2;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp_2;
    if (isInterface(tmp0, Collection)) {
      tmp_2 = tmp0.q();
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp$ret$2 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s_0 = tmp0.l();
    while (_iterator__ex2g4s_0.m()) {
      var element_0 = _iterator__ex2g4s_0.n();
      if (element_0.a() == null) {
        tmp$ret$2 = true;
        break $l$block_0;
      }
    }
    tmp$ret$2 = false;
  }
  tmp_1.e1s_1 = tmp$ret$2;
  var tmp0_0 = this.c1s_1;
  var tmp$ret$4;
  $l$block_2: {
    // Inline function 'kotlin.collections.all' call
    var tmp_3;
    if (isInterface(tmp0_0, Collection)) {
      tmp_3 = tmp0_0.q();
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp$ret$4 = true;
      break $l$block_2;
    }
    var _iterator__ex2g4s_1 = tmp0_0.l();
    while (_iterator__ex2g4s_1.m()) {
      var element_1 = _iterator__ex2g4s_1.n();
      var tmp0_elvis_lhs_0 = element_1.a();
      if (!((tmp0_elvis_lhs_0 == null ? 2147483647 : tmp0_elvis_lhs_0) > 0)) {
        tmp$ret$4 = false;
        break $l$block_2;
      }
    }
    tmp$ret$4 = true;
  }
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!tmp$ret$4) {
    var message = 'Failed requirement.';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp0_1 = this.c1s_1;
  var tmp$ret$9;
  $l$block_3: {
    // Inline function 'kotlin.collections.count' call
    var tmp_4;
    if (isInterface(tmp0_1, Collection)) {
      tmp_4 = tmp0_1.q();
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp$ret$9 = 0;
      break $l$block_3;
    }
    var count = 0;
    var _iterator__ex2g4s_2 = tmp0_1.l();
    while (_iterator__ex2g4s_2.m()) {
      var element_2 = _iterator__ex2g4s_2.n();
      if (element_2.a() == null) {
        count = count + 1 | 0;
        checkCountOverflow(count);
      }
    }
    tmp$ret$9 = count;
  }
  // Inline function 'kotlin.require' call
  if (!(tmp$ret$9 <= 1)) {
    // Inline function 'kotlin.collections.filter' call
    var tmp0_2 = this.c1s_1;
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s_3 = tmp0_2.l();
    while (_iterator__ex2g4s_3.m()) {
      var element_3 = _iterator__ex2g4s_3.n();
      if (element_3.a() == null) {
        destination.j(element_3);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
    var _iterator__ex2g4s_4 = destination.l();
    while (_iterator__ex2g4s_4.m()) {
      var item = _iterator__ex2g4s_4.n();
      var tmp$ret$14 = item.d1r_1;
      destination_0.j(tmp$ret$14);
    }
    var fieldNames = destination_0;
    var message_0 = 'At most one variable-length numeric field in a row is allowed, but got several: ' + toString(fieldNames) + '. ' + "Parsing is undefined: for example, with variable-length month number and variable-length day of month, '111' can be parsed as Jan 11th or Nov 1st.";
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
}
protoOf(NumberSpanParserOperation).z1r = function (storage, input, startIndex) {
  if ((startIndex + this.d1s_1 | 0) > charSequenceLength(input)) {
    var tmp = Companion_instance_6;
    return tmp.s1r(startIndex, NumberSpanParserOperation$consume$lambda(this));
  }
  var digitsInRow = {_v: 0};
  while ((startIndex + digitsInRow._v | 0) < charSequenceLength(input) && isAsciiDigit(charSequenceGet(input, startIndex + digitsInRow._v | 0))) {
    digitsInRow._v = digitsInRow._v + 1 | 0;
    digitsInRow._v;
  }
  if (digitsInRow._v < this.d1s_1) {
    var tmp_0 = Companion_instance_6;
    return tmp_0.s1r(startIndex, NumberSpanParserOperation$consume$lambda_0(digitsInRow, this));
  }
  var index = startIndex;
  var inductionVariable = 0;
  var last = this.c1s_1.o() - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0_elvis_lhs = this.c1s_1.p(i).a();
      var length = tmp0_elvis_lhs == null ? (digitsInRow._v - this.d1s_1 | 0) + 1 | 0 : tmp0_elvis_lhs;
      var error = this.c1s_1.p(i).b1r(storage, input, index, index + length | 0);
      if (!(error == null)) {
        var tmp2 = index;
        // Inline function 'kotlin.text.substring' call
        var endIndex = index + length | 0;
        var numberString = toString(charSequenceSubSequence(input, tmp2, endIndex));
        var tmp_1 = Companion_instance_6;
        var tmp_2 = index;
        return tmp_1.s1r(tmp_2, NumberSpanParserOperation$consume$lambda_1(numberString, this, i, error));
      }
      index = index + length | 0;
    }
     while (inductionVariable <= last);
  return Companion_instance_6.r1r(index);
};
protoOf(NumberSpanParserOperation).toString = function () {
  return _get_whatThisExpects__4pg11j(this);
};
function SignedIntParser(minDigits, maxDigits, spacePadding, setter, name, plusOnExceedsWidth) {
  var parsers = mutableListOf([spaceAndZeroPaddedUnsignedInt(minDigits, maxDigits, spacePadding, setter, name, true)]);
  if (!(plusOnExceedsWidth == null)) {
    parsers.j(spaceAndZeroPaddedUnsignedInt(minDigits, plusOnExceedsWidth, spacePadding, setter, name));
    parsers.j(new ParserStructure(listOf_0([new PlainStringParserOperation('+'), new NumberSpanParserOperation(listOf(new UnsignedIntConsumer(plusOnExceedsWidth + 1 | 0, maxDigits, setter, name, false)))]), emptyList()));
  } else {
    parsers.j(spaceAndZeroPaddedUnsignedInt(minDigits, maxDigits, spacePadding, setter, name));
  }
  return new ParserStructure(emptyList(), parsers);
}
function PlainStringParserOperation$consume$lambda(this$0) {
  return function () {
    return "Unexpected end of input: yet to parse '" + this$0.f1s_1 + "'";
  };
}
function PlainStringParserOperation$consume$lambda_0(this$0, $input, $startIndex, $i) {
  return function () {
    var tmp0 = $input;
    var tmp2 = $startIndex;
    // Inline function 'kotlin.text.substring' call
    var endIndex = ($startIndex + $i | 0) + 1 | 0;
    var tmp$ret$0 = toString(charSequenceSubSequence(tmp0, tmp2, endIndex));
    return 'Expected ' + this$0.f1s_1 + ' but got ' + tmp$ret$0;
  };
}
function PlainStringParserOperation(string) {
  this.f1s_1 = string;
  // Inline function 'kotlin.text.isNotEmpty' call
  var this_0 = this.f1s_1;
  // Inline function 'kotlin.require' call
  if (!(charSequenceLength(this_0) > 0)) {
    var message = 'Empty string is not allowed';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!!isAsciiDigit(charCodeAt(this.f1s_1, 0))) {
    var message_0 = "String '" + this.f1s_1 + "' starts with a digit";
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  // Inline function 'kotlin.require' call
  if (!!isAsciiDigit(charCodeAt(this.f1s_1, this.f1s_1.length - 1 | 0))) {
    var message_1 = "String '" + this.f1s_1 + "' ends with a digit";
    throw IllegalArgumentException_init_$Create$(toString(message_1));
  }
}
protoOf(PlainStringParserOperation).z1r = function (storage, input, startIndex) {
  if ((startIndex + this.f1s_1.length | 0) > charSequenceLength(input)) {
    var tmp = Companion_instance_6;
    return tmp.s1r(startIndex, PlainStringParserOperation$consume$lambda(this));
  }
  var inductionVariable = 0;
  var last = charSequenceLength(this.f1s_1) - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!(charSequenceGet(input, startIndex + i | 0) === charCodeAt(this.f1s_1, i))) {
        var tmp_0 = Companion_instance_6;
        return tmp_0.s1r(startIndex, PlainStringParserOperation$consume$lambda_0(this, input, startIndex, i));
      }
    }
     while (inductionVariable <= last);
  return Companion_instance_6.r1r(startIndex + this.f1s_1.length | 0);
};
protoOf(PlainStringParserOperation).toString = function () {
  return "'" + this.f1s_1 + "'";
};
function UnconditionalModification() {
}
function spaceAndZeroPaddedUnsignedInt$numberOfRequiredLengths($withMinus, $setter, $name, minNumberLength, maxNumberLength) {
  // Inline function 'kotlin.check' call
  if (!(maxNumberLength >= (1 + ($withMinus ? 1 : 0) | 0))) {
    throw IllegalStateException_init_$Create$('Check failed.');
  }
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = ArrayList_init_$Create$();
  if ($withMinus) {
    this_0.j(new PlainStringParserOperation('-'));
  }
  this_0.j(new NumberSpanParserOperation(listOf(new UnsignedIntConsumer(minNumberLength - ($withMinus ? 1 : 0) | 0, maxNumberLength - ($withMinus ? 1 : 0) | 0, $setter, $name, $withMinus))));
  var tmp$ret$4 = this_0.u2();
  return new ParserStructure(tmp$ret$4, emptyList());
}
function get_POWERS_OF_TEN() {
  _init_properties_math_kt__tgcmt4();
  return POWERS_OF_TEN;
}
var POWERS_OF_TEN;
var properties_initialized_math_kt_amm9wq;
function _init_properties_math_kt__tgcmt4() {
  if (!properties_initialized_math_kt_amm9wq) {
    properties_initialized_math_kt_amm9wq = true;
    // Inline function 'kotlin.intArrayOf' call
    POWERS_OF_TEN = new Int32Array([1, 10, 100, 1000, 10000, 100000, 1000000, 10000000, 100000000, 1000000000]);
  }
}
function isAsciiDigit(_this__u8e3s4) {
  return _Char___init__impl__6a9atx(48) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(57) : false;
}
function asciiDigitToInt(_this__u8e3s4) {
  return Char__minus_impl_a2frrh(_this__u8e3s4, _Char___init__impl__6a9atx(48));
}
function TimeBasedDateTimeUnitSerializer$descriptor$delegate$lambda() {
  return buildClassSerialDescriptor('kotlinx.datetime.TimeBased', [], TimeBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda);
}
function TimeBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda($this$buildClassSerialDescriptor) {
  // Inline function 'kotlinx.serialization.descriptors.element' call
  var elementName = 'nanoseconds';
  var annotations = emptyList();
  // Inline function 'kotlinx.serialization.serializer' call
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_0 = serializer(createKType(PrimitiveClasses_getInstance().hb(), arrayOf([]), false));
  var descriptor = (isInterface(this_0, KSerializer) ? this_0 : THROW_CCE()).fp();
  $this$buildClassSerialDescriptor.or(elementName, descriptor, annotations, false);
  return Unit_instance;
}
function TimeBasedDateTimeUnitSerializer$_get_descriptor_$ref_ezonyw() {
  return function (p0) {
    return p0.fp();
  };
}
function TimeBasedDateTimeUnitSerializer() {
  TimeBasedDateTimeUnitSerializer_instance = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.g1s_1 = lazy_0(tmp_0, TimeBasedDateTimeUnitSerializer$descriptor$delegate$lambda);
}
protoOf(TimeBasedDateTimeUnitSerializer).fp = function () {
  var tmp0 = this.g1s_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('descriptor', 1, tmp, TimeBasedDateTimeUnitSerializer$_get_descriptor_$ref_ezonyw(), null);
  return tmp0.w();
};
protoOf(TimeBasedDateTimeUnitSerializer).h1s = function (encoder, value) {
  // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
  var descriptor = this.fp();
  var composite = encoder.ss(descriptor);
  composite.du(TimeBasedDateTimeUnitSerializer_getInstance().fp(), 0, value.i1l_1);
  composite.ts(descriptor);
};
protoOf(TimeBasedDateTimeUnitSerializer).gp = function (encoder, value) {
  return this.h1s(encoder, value instanceof TimeBased ? value : THROW_CCE());
};
protoOf(TimeBasedDateTimeUnitSerializer).hp = function (decoder) {
  var seen = {_v: false};
  var nanoseconds = {_v: 0n};
  // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
  var descriptor = this.fp();
  var composite = decoder.ss(descriptor);
  if (composite.it()) {
    nanoseconds._v = composite.ys(TimeBasedDateTimeUnitSerializer_getInstance().fp(), 0);
    seen._v = true;
  } else {
    loop: while (true) {
      var elementIndex = composite.jt(TimeBasedDateTimeUnitSerializer_getInstance().fp());
      switch (elementIndex) {
        case 0:
          nanoseconds._v = composite.ys(TimeBasedDateTimeUnitSerializer_getInstance().fp(), 0);
          seen._v = true;
          break;
        case -1:
          break loop;
        default:
          throwUnknownIndexException(elementIndex);
          break;
      }
    }
  }
  var result = Unit_instance;
  composite.ts(descriptor);
  if (!seen._v)
    throw MissingFieldException_init_$Create$('nanoseconds', this.fp().gq());
  return new TimeBased(nanoseconds._v);
};
var TimeBasedDateTimeUnitSerializer_instance;
function TimeBasedDateTimeUnitSerializer_getInstance() {
  if (TimeBasedDateTimeUnitSerializer_instance == null)
    new TimeBasedDateTimeUnitSerializer();
  return TimeBasedDateTimeUnitSerializer_instance;
}
function _get_impl__d88w17($this) {
  var tmp0 = $this.i1s_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('impl', 1, tmp, DateBasedDateTimeUnitSerializer$_get_impl_$ref_m860rs(), null);
  return tmp0.w();
}
function DateBasedDateTimeUnitSerializer$impl$delegate$lambda() {
  var tmp = getKClass(DateBased);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(DayBased), getKClass(MonthBased)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [DayBasedDateTimeUnitSerializer_getInstance(), MonthBasedDateTimeUnitSerializer_getInstance()];
  return new SealedClassSerializer('kotlinx.datetime.DateTimeUnit.DateBased', tmp, tmp_0, tmp$ret$5);
}
function DateBasedDateTimeUnitSerializer$_get_impl_$ref_m860rs() {
  return function (p0) {
    return _get_impl__d88w17(p0);
  };
}
function DateBasedDateTimeUnitSerializer() {
  DateBasedDateTimeUnitSerializer_instance = this;
  AbstractPolymorphicSerializer.call(this);
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.i1s_1 = lazy_0(tmp_0, DateBasedDateTimeUnitSerializer$impl$delegate$lambda);
}
protoOf(DateBasedDateTimeUnitSerializer).ip = function (decoder, klassName) {
  return _get_impl__d88w17(this).ip(decoder, klassName);
};
protoOf(DateBasedDateTimeUnitSerializer).j1s = function (encoder, value) {
  return _get_impl__d88w17(this).kp(encoder, value);
};
protoOf(DateBasedDateTimeUnitSerializer).kp = function (encoder, value) {
  return this.j1s(encoder, value instanceof DateBased ? value : THROW_CCE());
};
protoOf(DateBasedDateTimeUnitSerializer).jp = function () {
  return getKClass(DateBased);
};
protoOf(DateBasedDateTimeUnitSerializer).fp = function () {
  return _get_impl__d88w17(this).fp();
};
var DateBasedDateTimeUnitSerializer_instance;
function DateBasedDateTimeUnitSerializer_getInstance() {
  if (DateBasedDateTimeUnitSerializer_instance == null)
    new DateBasedDateTimeUnitSerializer();
  return DateBasedDateTimeUnitSerializer_instance;
}
function DayBasedDateTimeUnitSerializer$descriptor$delegate$lambda() {
  return buildClassSerialDescriptor('kotlinx.datetime.DayBased', [], DayBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda);
}
function DayBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda($this$buildClassSerialDescriptor) {
  // Inline function 'kotlinx.serialization.descriptors.element' call
  var annotations = emptyList();
  // Inline function 'kotlinx.serialization.serializer' call
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_0 = serializer(createKType(PrimitiveClasses_getInstance().gb(), arrayOf([]), false));
  var descriptor = (isInterface(this_0, KSerializer) ? this_0 : THROW_CCE()).fp();
  $this$buildClassSerialDescriptor.or('days', descriptor, annotations, false);
  return Unit_instance;
}
function DayBasedDateTimeUnitSerializer$_get_descriptor_$ref_2ycvl3() {
  return function (p0) {
    return p0.fp();
  };
}
function DayBasedDateTimeUnitSerializer() {
  DayBasedDateTimeUnitSerializer_instance = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.k1s_1 = lazy_0(tmp_0, DayBasedDateTimeUnitSerializer$descriptor$delegate$lambda);
}
protoOf(DayBasedDateTimeUnitSerializer).fp = function () {
  var tmp0 = this.k1s_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('descriptor', 1, tmp, DayBasedDateTimeUnitSerializer$_get_descriptor_$ref_2ycvl3(), null);
  return tmp0.w();
};
protoOf(DayBasedDateTimeUnitSerializer).l1s = function (encoder, value) {
  // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
  var descriptor = this.fp();
  var composite = encoder.ss(descriptor);
  composite.cu(DayBasedDateTimeUnitSerializer_getInstance().fp(), 0, value.o1l_1);
  composite.ts(descriptor);
};
protoOf(DayBasedDateTimeUnitSerializer).gp = function (encoder, value) {
  return this.l1s(encoder, value instanceof DayBased ? value : THROW_CCE());
};
protoOf(DayBasedDateTimeUnitSerializer).hp = function (decoder) {
  var seen = {_v: false};
  var days = {_v: 0};
  // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
  var descriptor = this.fp();
  var composite = decoder.ss(descriptor);
  if (composite.it()) {
    days._v = composite.xs(DayBasedDateTimeUnitSerializer_getInstance().fp(), 0);
    seen._v = true;
  } else {
    loop: while (true) {
      var elementIndex = composite.jt(DayBasedDateTimeUnitSerializer_getInstance().fp());
      switch (elementIndex) {
        case 0:
          days._v = composite.xs(DayBasedDateTimeUnitSerializer_getInstance().fp(), 0);
          seen._v = true;
          break;
        case -1:
          break loop;
        default:
          throwUnknownIndexException(elementIndex);
          break;
      }
    }
  }
  var result = Unit_instance;
  composite.ts(descriptor);
  if (!seen._v)
    throw MissingFieldException_init_$Create$('days', this.fp().gq());
  return new DayBased(days._v);
};
var DayBasedDateTimeUnitSerializer_instance;
function DayBasedDateTimeUnitSerializer_getInstance() {
  if (DayBasedDateTimeUnitSerializer_instance == null)
    new DayBasedDateTimeUnitSerializer();
  return DayBasedDateTimeUnitSerializer_instance;
}
function MonthBasedDateTimeUnitSerializer$descriptor$delegate$lambda() {
  return buildClassSerialDescriptor('kotlinx.datetime.MonthBased', [], MonthBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda);
}
function MonthBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda($this$buildClassSerialDescriptor) {
  // Inline function 'kotlinx.serialization.descriptors.element' call
  var annotations = emptyList();
  // Inline function 'kotlinx.serialization.serializer' call
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_0 = serializer(createKType(PrimitiveClasses_getInstance().gb(), arrayOf([]), false));
  var descriptor = (isInterface(this_0, KSerializer) ? this_0 : THROW_CCE()).fp();
  $this$buildClassSerialDescriptor.or('months', descriptor, annotations, false);
  return Unit_instance;
}
function MonthBasedDateTimeUnitSerializer$_get_descriptor_$ref_vroatn() {
  return function (p0) {
    return p0.fp();
  };
}
function MonthBasedDateTimeUnitSerializer() {
  MonthBasedDateTimeUnitSerializer_instance = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.m1s_1 = lazy_0(tmp_0, MonthBasedDateTimeUnitSerializer$descriptor$delegate$lambda);
}
protoOf(MonthBasedDateTimeUnitSerializer).fp = function () {
  var tmp0 = this.m1s_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('descriptor', 1, tmp, MonthBasedDateTimeUnitSerializer$_get_descriptor_$ref_vroatn(), null);
  return tmp0.w();
};
protoOf(MonthBasedDateTimeUnitSerializer).n1s = function (encoder, value) {
  // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
  var descriptor = this.fp();
  var composite = encoder.ss(descriptor);
  composite.cu(MonthBasedDateTimeUnitSerializer_getInstance().fp(), 0, value.p1l_1);
  composite.ts(descriptor);
};
protoOf(MonthBasedDateTimeUnitSerializer).gp = function (encoder, value) {
  return this.n1s(encoder, value instanceof MonthBased ? value : THROW_CCE());
};
protoOf(MonthBasedDateTimeUnitSerializer).hp = function (decoder) {
  var seen = {_v: false};
  var months = {_v: 0};
  // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
  var descriptor = this.fp();
  var composite = decoder.ss(descriptor);
  if (composite.it()) {
    months._v = composite.xs(MonthBasedDateTimeUnitSerializer_getInstance().fp(), 0);
    seen._v = true;
  } else {
    loop: while (true) {
      var elementIndex = composite.jt(MonthBasedDateTimeUnitSerializer_getInstance().fp());
      switch (elementIndex) {
        case 0:
          months._v = composite.xs(MonthBasedDateTimeUnitSerializer_getInstance().fp(), 0);
          seen._v = true;
          break;
        case -1:
          break loop;
        default:
          throwUnknownIndexException(elementIndex);
          break;
      }
    }
  }
  var result = Unit_instance;
  composite.ts(descriptor);
  if (!seen._v)
    throw MissingFieldException_init_$Create$('months', this.fp().gq());
  return new MonthBased(months._v);
};
var MonthBasedDateTimeUnitSerializer_instance;
function MonthBasedDateTimeUnitSerializer_getInstance() {
  if (MonthBasedDateTimeUnitSerializer_instance == null)
    new MonthBasedDateTimeUnitSerializer();
  return MonthBasedDateTimeUnitSerializer_instance;
}
function _get_impl__d88w17_0($this) {
  var tmp0 = $this.o1s_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('impl', 1, tmp, DateTimeUnitSerializer$_get_impl_$ref_2y1hvx(), null);
  return tmp0.w();
}
function DateTimeUnitSerializer$impl$delegate$lambda() {
  var tmp = getKClass(DateTimeUnit);
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(DayBased), getKClass(MonthBased), getKClass(TimeBased)];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$5 = [DayBasedDateTimeUnitSerializer_getInstance(), MonthBasedDateTimeUnitSerializer_getInstance(), TimeBasedDateTimeUnitSerializer_getInstance()];
  return new SealedClassSerializer('kotlinx.datetime.DateTimeUnit', tmp, tmp_0, tmp$ret$5);
}
function DateTimeUnitSerializer$_get_impl_$ref_2y1hvx() {
  return function (p0) {
    return _get_impl__d88w17_0(p0);
  };
}
function DateTimeUnitSerializer() {
  DateTimeUnitSerializer_instance = this;
  AbstractPolymorphicSerializer.call(this);
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  tmp.o1s_1 = lazy_0(tmp_0, DateTimeUnitSerializer$impl$delegate$lambda);
}
protoOf(DateTimeUnitSerializer).ip = function (decoder, klassName) {
  return _get_impl__d88w17_0(this).ip(decoder, klassName);
};
protoOf(DateTimeUnitSerializer).p1s = function (encoder, value) {
  return _get_impl__d88w17_0(this).kp(encoder, value);
};
protoOf(DateTimeUnitSerializer).kp = function (encoder, value) {
  return this.p1s(encoder, value instanceof DateTimeUnit ? value : THROW_CCE());
};
protoOf(DateTimeUnitSerializer).jp = function () {
  return getKClass(DateTimeUnit);
};
protoOf(DateTimeUnitSerializer).fp = function () {
  return _get_impl__d88w17_0(this).fp();
};
var DateTimeUnitSerializer_instance;
function DateTimeUnitSerializer_getInstance() {
  if (DateTimeUnitSerializer_instance == null)
    new DateTimeUnitSerializer();
  return DateTimeUnitSerializer_instance;
}
function throwUnknownIndexException(index) {
  throw SerializationException_init_$Create$('An unknown field for index ' + index);
}
function LocalDateSerializer() {
  LocalDateSerializer_instance = this;
  this.q1s_1 = PrimitiveSerialDescriptor('kotlinx.datetime.LocalDate', STRING_getInstance());
}
protoOf(LocalDateSerializer).fp = function () {
  return this.q1s_1;
};
protoOf(LocalDateSerializer).hp = function (decoder) {
  return Companion_getInstance_7().v1s(decoder.ns());
};
protoOf(LocalDateSerializer).w1s = function (encoder, value) {
  encoder.wt(value.toString());
};
protoOf(LocalDateSerializer).gp = function (encoder, value) {
  return this.w1s(encoder, value instanceof LocalDate ? value : THROW_CCE());
};
var LocalDateSerializer_instance;
function LocalDateSerializer_getInstance() {
  if (LocalDateSerializer_instance == null)
    new LocalDateSerializer();
  return LocalDateSerializer_instance;
}
function YearMonthSerializer() {
  YearMonthSerializer_instance = this;
  this.x1s_1 = PrimitiveSerialDescriptor('kotlinx.datetime.YearMonth', STRING_getInstance());
}
protoOf(YearMonthSerializer).fp = function () {
  return this.x1s_1;
};
protoOf(YearMonthSerializer).hp = function (decoder) {
  return Companion_instance_8.y1s(decoder.ns());
};
protoOf(YearMonthSerializer).z1s = function (encoder, value) {
  encoder.wt(value.toString());
};
protoOf(YearMonthSerializer).gp = function (encoder, value) {
  return this.z1s(encoder, value instanceof YearMonth ? value : THROW_CCE());
};
var YearMonthSerializer_instance;
function YearMonthSerializer_getInstance() {
  if (YearMonthSerializer_instance == null)
    new YearMonthSerializer();
  return YearMonthSerializer_instance;
}
function Companion_7() {
  Companion_instance_7 = this;
  this.r1s_1 = new LocalDate(-999999999, 1, 1);
  this.s1s_1 = new LocalDate(999999999, 12, 31);
  this.t1s_1 = -365243219162n;
  this.u1s_1 = 365241780471n;
}
protoOf(Companion_7).a1t = function (input, format) {
  return format.yl(input);
};
protoOf(Companion_7).v1s = function (input, format, $super) {
  format = format === VOID ? getIsoDateFormat() : format;
  return $super === VOID ? this.a1t(input, format) : $super.a1t.call(this, input, format);
};
protoOf(Companion_7).b1t = function (epochDays) {
  // Inline function 'kotlin.require' call
  if (!(-365243219162n <= epochDays ? epochDays <= 365241780471n : false)) {
    var message = 'Invalid date: epoch day ' + epochDays.toString() + ' is outside the boundaries of LocalDate';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.Long.plus' call
  var zeroDay = add(epochDays, fromInt(719528));
  // Inline function 'kotlin.Long.minus' call
  var this_0 = zeroDay;
  zeroDay = subtract(this_0, fromInt(60));
  var adjust = 0n;
  if (zeroDay < 0n) {
    // Inline function 'kotlin.Long.plus' call
    var this_1 = zeroDay;
    // Inline function 'kotlin.Long.div' call
    var this_2 = add(this_1, fromInt(1));
    // Inline function 'kotlin.Long.minus' call
    var this_3 = divide(this_2, fromInt(146097));
    var adjustCycles = subtract(this_3, fromInt(1));
    // Inline function 'kotlin.Long.times' call
    adjust = multiply(adjustCycles, fromInt(400));
    var tmp = zeroDay;
    // Inline function 'kotlin.Long.times' call
    var this_4 = negate(adjustCycles);
    var tmp$ret$8 = multiply(this_4, fromInt(146097));
    zeroDay = add(tmp, tmp$ret$8);
  }
  // Inline function 'kotlin.Long.plus' call
  var this_5 = multiply(numberToLong(400), zeroDay);
  // Inline function 'kotlin.Long.div' call
  var this_6 = add(this_5, fromInt(591));
  var yearEst = divide(this_6, fromInt(146097));
  var tmp_0 = zeroDay;
  var tmp_1 = multiply(numberToLong(365), yearEst);
  // Inline function 'kotlin.Long.div' call
  var this_7 = yearEst;
  var tmp$ret$11 = divide(this_7, fromInt(4));
  var tmp_2 = add(tmp_1, tmp$ret$11);
  // Inline function 'kotlin.Long.div' call
  var this_8 = yearEst;
  var tmp$ret$12 = divide(this_8, fromInt(100));
  var tmp_3 = subtract(tmp_2, tmp$ret$12);
  // Inline function 'kotlin.Long.div' call
  var this_9 = yearEst;
  var tmp$ret$13 = divide(this_9, fromInt(400));
  var doyEst = subtract(tmp_0, add(tmp_3, tmp$ret$13));
  if (doyEst < 0n) {
    var _unary__edvuaz = yearEst;
    yearEst = subtract(_unary__edvuaz, get_ONE());
    var tmp_4 = zeroDay;
    var tmp_5 = multiply(numberToLong(365), yearEst);
    // Inline function 'kotlin.Long.div' call
    var this_10 = yearEst;
    var tmp$ret$14 = divide(this_10, fromInt(4));
    var tmp_6 = add(tmp_5, tmp$ret$14);
    // Inline function 'kotlin.Long.div' call
    var this_11 = yearEst;
    var tmp$ret$15 = divide(this_11, fromInt(100));
    var tmp_7 = subtract(tmp_6, tmp$ret$15);
    // Inline function 'kotlin.Long.div' call
    var this_12 = yearEst;
    var tmp$ret$16 = divide(this_12, fromInt(400));
    doyEst = subtract(tmp_4, add(tmp_7, tmp$ret$16));
  }
  yearEst = add(yearEst, adjust);
  var marchDoy0 = convertToInt(doyEst);
  var marchMonth0 = (imul(marchDoy0, 5) + 2 | 0) / 153 | 0;
  var month = ((marchMonth0 + 2 | 0) % 12 | 0) + 1 | 0;
  var dom = (marchDoy0 - ((imul(marchMonth0, 306) + 5 | 0) / 10 | 0) | 0) + 1 | 0;
  var tmp0 = yearEst;
  // Inline function 'kotlin.Long.plus' call
  var other = marchMonth0 / 10 | 0;
  yearEst = add(tmp0, fromInt(other));
  return new LocalDate(convertToInt(yearEst), month, dom);
};
var Companion_instance_7;
function Companion_getInstance_7() {
  if (Companion_instance_7 == null)
    new Companion_7();
  return Companion_instance_7;
}
function Formats() {
  Formats_instance = this;
  this.c1m_1 = get_ISO_DATE_BASIC();
}
protoOf(Formats).d1m = function () {
  return get_ISO_DATE();
};
var Formats_instance;
function Formats_getInstance() {
  if (Formats_instance == null)
    new Formats();
  return Formats_instance;
}
function resolvePreviousValid($this, year, month, day) {
  // Inline function 'kotlin.math.min' call
  var b = monthLength(month, isLeapYear(year));
  var newDay = Math.min(day, b);
  return new LocalDate(year, month, newDay);
}
function LocalDate(year, month, day) {
  Companion_getInstance_7();
  this.n1n_1 = year;
  this.o1n_1 = day;
  this.p1n_1 = month;
  // Inline function 'kotlin.require' call
  if (!isValidYear(this.n1n_1)) {
    var message = 'Invalid date: the year is out of range';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var containsArg = this.p1n_1;
  // Inline function 'kotlin.require' call
  if (!(1 <= containsArg ? containsArg <= 12 : false)) {
    var message_0 = 'Invalid date: month must be a number between 1 and 12, got ' + this.p1n_1;
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  var containsArg_0 = this.o1n_1;
  // Inline function 'kotlin.require' call
  if (!(1 <= containsArg_0 ? containsArg_0 <= 31 : false)) {
    var message_1 = 'Invalid date: day of month must be a number between 1 and 31, got ' + this.o1n_1;
    throw IllegalArgumentException_init_$Create$(toString(message_1));
  }
  if (this.o1n_1 > 28 && this.o1n_1 > monthLength(this.p1n_1, isLeapYear(this.n1n_1))) {
    if (this.o1n_1 === 29) {
      throw IllegalArgumentException_init_$Create$("Invalid date 'February 29' as '" + this.n1n_1 + "' is not a leap year");
    } else {
      throw IllegalArgumentException_init_$Create$("Invalid date '" + Month_0(month).toString() + ' ' + this.o1n_1 + "'");
    }
  }
}
protoOf(LocalDate).c1t = function () {
  var y = fromInt(this.n1n_1);
  var m = fromInt(this.p1n_1);
  var total = 0n;
  total = add(total, multiply(numberToLong(365), y));
  if (y >= 0n) {
    var tmp = total;
    // Inline function 'kotlin.Long.plus' call
    // Inline function 'kotlin.Long.div' call
    var this_0 = add(y, fromInt(3));
    var tmp_0 = divide(this_0, fromInt(4));
    // Inline function 'kotlin.Long.plus' call
    // Inline function 'kotlin.Long.div' call
    var this_1 = add(y, fromInt(99));
    var tmp$ret$3 = divide(this_1, fromInt(100));
    var tmp_1 = subtract(tmp_0, tmp$ret$3);
    // Inline function 'kotlin.Long.plus' call
    // Inline function 'kotlin.Long.div' call
    var this_2 = add(y, fromInt(399));
    var tmp$ret$5 = divide(this_2, fromInt(400));
    total = add(tmp, add(tmp_1, tmp$ret$5));
  } else {
    var tmp_2 = total;
    // Inline function 'kotlin.Long.div' call
    var tmp_3 = divide(y, fromInt(-4));
    // Inline function 'kotlin.Long.div' call
    var tmp$ret$7 = divide(y, fromInt(-100));
    var tmp_4 = subtract(tmp_3, tmp$ret$7);
    // Inline function 'kotlin.Long.div' call
    var tmp$ret$8 = divide(y, fromInt(-400));
    total = subtract(tmp_2, add(tmp_4, tmp$ret$8));
  }
  var tmp_5 = total;
  // Inline function 'kotlin.Long.minus' call
  var this_3 = multiply(numberToLong(367), m);
  // Inline function 'kotlin.Long.div' call
  var this_4 = subtract(this_3, fromInt(362));
  var tmp$ret$10 = divide(this_4, fromInt(12));
  total = add(tmp_5, tmp$ret$10);
  var tmp0 = total;
  // Inline function 'kotlin.Long.plus' call
  var other = this.o1n_1 - 1 | 0;
  total = add(tmp0, fromInt(other));
  if (m > 2n) {
    var _unary__edvuaz = total;
    total = subtract(_unary__edvuaz, get_ONE());
    if (!isLeapYear(this.n1n_1)) {
      var _unary__edvuaz_0 = total;
      total = subtract(_unary__edvuaz_0, get_ONE());
    }
  }
  // Inline function 'kotlin.Long.minus' call
  var this_5 = total;
  return subtract(this_5, fromInt(719528));
};
protoOf(LocalDate).q1n = function () {
  return Month_0(this.p1n_1);
};
protoOf(LocalDate).i1n = function () {
  // Inline function 'kotlin.Long.plus' call
  var this_0 = this.c1t();
  // Inline function 'kotlin.mod' call
  var tmp0 = add(this_0, fromInt(3));
  // Inline function 'kotlin.mod' call
  var other = fromInt(7);
  var r = modulo(tmp0, other);
  var tmp$ret$1 = add(r, other & shiftRight((r ^ other) & (r | negate(r)), 63));
  var dow0 = convertToInt(tmp$ret$1);
  return DayOfWeek_0(dow0 + 1 | 0);
};
protoOf(LocalDate).k1n = function () {
  return (firstDayOfYear(this.q1n(), isLeapYear(this.n1n_1)) + this.o1n_1 | 0) - 1 | 0;
};
protoOf(LocalDate).d1t = function (other) {
  var y = compareTo(this.n1n_1, other.n1n_1);
  if (!(y === 0)) {
    return y;
  }
  var m = compareTo(this.p1n_1, other.p1n_1);
  if (!(m === 0)) {
    return m;
  }
  return compareTo(this.o1n_1, other.o1n_1);
};
protoOf(LocalDate).d = function (other) {
  return this.d1t(other instanceof LocalDate ? other : THROW_CCE());
};
protoOf(LocalDate).e1t = function (monthsToAdd) {
  if (monthsToAdd === 0n) {
    return this;
  }
  var tmp0 = multiply(numberToLong(this.n1n_1), 12n);
  // Inline function 'kotlin.Long.plus' call
  var other = this.p1n_1 - 1 | 0;
  var monthCount = add(tmp0, fromInt(other));
  var calcMonths = safeAdd(monthCount, monthsToAdd);
  // Inline function 'kotlin.floorDiv' call
  // Inline function 'kotlin.floorDiv' call
  var other_0 = fromInt(12);
  var q = divide(calcMonths, other_0);
  if ((calcMonths ^ other_0) < 0n && !(multiply(q, other_0) === calcMonths)) {
    var _unary__edvuaz = q;
    q = subtract(_unary__edvuaz, get_ONE());
  }
  var newYear = q;
  // Inline function 'kotlin.ranges.contains' call
  var this_0 = numberRangeToNumber(-999999999, 999999999);
  if (!contains(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), newYear)) {
    throw IllegalArgumentException_init_$Create$('The result of adding ' + monthsToAdd.toString() + ' months to ' + this.toString() + ' is out of LocalDate range.');
  }
  // Inline function 'kotlin.mod' call
  // Inline function 'kotlin.mod' call
  var other_1 = fromInt(12);
  var r = modulo(calcMonths, other_1);
  var tmp$ret$4 = add(r, other_1 & shiftRight((r ^ other_1) & (r | negate(r)), 63));
  var newMonth = convertToInt(tmp$ret$4) + 1 | 0;
  return resolvePreviousValid(this, convertToInt(newYear), newMonth, this.o1n_1);
};
protoOf(LocalDate).f1t = function (daysToAdd) {
  return daysToAdd === 0n ? this : Companion_getInstance_7().b1t(safeAdd(this.c1t(), daysToAdd));
};
protoOf(LocalDate).equals = function (other) {
  var tmp;
  if (this === other) {
    tmp = true;
  } else {
    var tmp_0;
    if (other instanceof LocalDate) {
      tmp_0 = this.d1t(other) === 0;
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  }
  return tmp;
};
protoOf(LocalDate).hashCode = function () {
  var yearValue = this.n1n_1;
  var monthValue = this.p1n_1;
  var dayValue = this.o1n_1;
  return yearValue & -2048 ^ (((yearValue << 11) + (monthValue << 6) | 0) + dayValue | 0);
};
protoOf(LocalDate).toString = function () {
  return format(this, Formats_getInstance().d1m());
};
function isValidYear(year) {
  return year >= -999999999 && year <= 999999999;
}
function plus_1(_this__u8e3s4, value, unit) {
  var tmp;
  try {
    var tmp_0;
    if (unit instanceof DayBased) {
      tmp_0 = _this__u8e3s4.f1t(safeMultiply(value, fromInt(unit.o1l_1)));
    } else {
      if (unit instanceof MonthBased) {
        tmp_0 = _this__u8e3s4.e1t(safeMultiply(value, fromInt(unit.p1l_1)));
      } else {
        noWhenBranchMatchedException();
      }
    }
    tmp = tmp_0;
  } catch ($p) {
    var tmp_1;
    if ($p instanceof ArithmeticException) {
      var e = $p;
      throw DateTimeArithmeticException_init_$Create$_0('Arithmetic overflow when adding a value to a date', e);
    } else {
      if ($p instanceof IllegalArgumentException) {
        var e_0 = $p;
        throw DateTimeArithmeticException_init_$Create$_0('Boundaries of LocalDate exceeded when adding a value', e_0);
      } else {
        throw $p;
      }
    }
  }
  return tmp;
}
function firstDayOfYear(_this__u8e3s4, leapYear) {
  var leap = leapYear ? 1 : 0;
  var tmp;
  switch (_this__u8e3s4.j2_1) {
    case 0:
      tmp = 1;
      break;
    case 1:
      tmp = 32;
      break;
    case 2:
      tmp = 60 + leap | 0;
      break;
    case 3:
      tmp = 91 + leap | 0;
      break;
    case 4:
      tmp = 121 + leap | 0;
      break;
    case 5:
      tmp = 152 + leap | 0;
      break;
    case 6:
      tmp = 182 + leap | 0;
      break;
    case 7:
      tmp = 213 + leap | 0;
      break;
    case 8:
      tmp = 244 + leap | 0;
      break;
    case 9:
      tmp = 274 + leap | 0;
      break;
    case 10:
      tmp = 305 + leap | 0;
      break;
    case 11:
      tmp = 335 + leap | 0;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function Companion_8() {
}
protoOf(Companion_8).g1t = function (input, format) {
  return format.yl(input);
};
protoOf(Companion_8).y1s = function (input, format, $super) {
  format = format === VOID ? Formats_instance_0.d1m() : format;
  return $super === VOID ? this.g1t(input, format) : $super.g1t.call(this, input, format);
};
var Companion_instance_8;
function Companion_getInstance_8() {
  return Companion_instance_8;
}
function Formats_0() {
}
protoOf(Formats_0).d1m = function () {
  return get_ISO_YEAR_MONTH();
};
var Formats_instance_0;
function Formats_getInstance_0() {
  return Formats_instance_0;
}
function YearMonth$_get_year_$ref_chp4n6() {
  return function (p0) {
    return p0.t1o_1;
  };
}
function YearMonth$_get_month_$ref_9rphhd() {
  return function (p0) {
    return p0.q1n();
  };
}
function YearMonth(year, month) {
  this.t1o_1 = year;
  this.u1o_1 = month;
  // Inline function 'kotlin.require' call
  if (!(1 <= month ? month <= 12 : false)) {
    var message = 'Month must be in 1..12, but was ' + month;
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var containsLower = Companion_getInstance_7().r1s_1.n1n_1;
  var containsUpper = Companion_getInstance_7().s1s_1.n1n_1;
  var containsArg = this.t1o_1;
  // Inline function 'kotlin.require' call
  if (!(containsLower <= containsArg ? containsArg <= containsUpper : false)) {
    var message_0 = 'Year ' + this.t1o_1 + ' is out of range: ' + Companion_getInstance_7().r1s_1.n1n_1 + '..' + Companion_getInstance_7().s1s_1.n1n_1;
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
}
protoOf(YearMonth).q1n = function () {
  return Month_0(this.u1o_1);
};
protoOf(YearMonth).h1t = function (other) {
  var tmp = KProperty1;
  var tmp_0 = getPropertyCallableRef('year', 1, tmp, YearMonth$_get_year_$ref_chp4n6(), null);
  var tmp_1 = KProperty1;
  return compareValuesBy(this, other, [tmp_0, getPropertyCallableRef('month', 1, tmp_1, YearMonth$_get_month_$ref_9rphhd(), null)]);
};
protoOf(YearMonth).d = function (other) {
  return this.h1t(other instanceof YearMonth ? other : THROW_CCE());
};
protoOf(YearMonth).toString = function () {
  return Formats_instance_0.d1m().e1m(this);
};
protoOf(YearMonth).equals = function (other) {
  var tmp;
  var tmp_0;
  if (other instanceof YearMonth) {
    tmp_0 = this.t1o_1 === other.t1o_1;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = this.q1n().equals(other.q1n());
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(YearMonth).hashCode = function () {
  return imul(this.t1o_1, 31) + this.q1n().hashCode() | 0;
};
function safeAdd(a, b) {
  var sum = add(a, b);
  if ((a ^ sum) < 0n && (a ^ b) >= 0n) {
    throw ArithmeticException_init_$Create$('Addition overflows a long: ' + a.toString() + ' + ' + b.toString());
  }
  return sum;
}
function safeMultiply(a, b) {
  if (b === 1n) {
    return a;
  }
  if (a === 1n) {
    return b;
  }
  if (a === 0n || b === 0n) {
    return 0n;
  }
  var total = multiply(a, b);
  if (!(divide(total, b) === a) || (a === -9223372036854775808n && b === -1n) || (b === -9223372036854775808n && a === -1n)) {
    throw ArithmeticException_init_$Create$('Multiplication overflows a long: ' + a.toString() + ' * ' + b.toString());
  }
  return total;
}
function safeMultiply_0(a, b) {
  var total = multiply(fromInt(a), fromInt(b));
  if (total < -2147483648n || total > 2147483647n) {
    throw ArithmeticException_init_$Create$('Multiplication overflows an int: ' + a + ' * ' + b);
  }
  return convertToInt(total);
}
//region block: post-declaration
protoOf(Builder).t1m = chars;
protoOf(Builder).z1m = build;
protoOf(Builder).b1o = addFormatStructureForYearMonth;
protoOf(Builder).u1m = day;
protoOf(Builder).v1m = day$default;
protoOf(Builder).p1m = year;
protoOf(Builder).q1m = year$default;
protoOf(Builder).r1m = monthNumber;
protoOf(Builder).s1m = monthNumber$default;
protoOf(Builder_0).t1m = chars;
protoOf(Builder_0).z1m = build;
protoOf(Builder_0).p1m = year;
protoOf(Builder_0).q1m = year$default;
protoOf(Builder_0).r1m = monthNumber;
protoOf(Builder_0).s1m = monthNumber$default;
protoOf(PropertyAccessor).t1p = getterNotNull;
protoOf(SpacePaddedFormatter).n1m = format$default;
protoOf(ConcatenatedFormatter).n1m = format$default;
protoOf(UnsignedIntFormatterStructure).n1m = format$default;
protoOf(SignedIntFormatterStructure).n1m = format$default;
protoOf(ConstantStringFormatterStructure).n1m = format$default;
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
Companion_instance_1 = new Companion_1();
Companion_instance_2 = new Companion_2();
Companion_instance_4 = new Companion_4();
Companion_instance_5 = new Companion_5();
ExpectedInt_instance = new ExpectedInt();
Companion_instance_6 = new Companion_6();
Companion_instance_8 = new Companion_8();
Formats_instance_0 = new Formats_0();
//endregion
//region block: exports
export {
  LocalDateSerializer_getInstance as LocalDateSerializer_getInstance2ir4dj2eqtzf2,
  Companion_getInstance_7 as Companion_getInstancefc1kb6w5z78x,
  LocalDate as LocalDate31mqn6zavbpi8,
};
//endregion

//# sourceMappingURL=Kotlin-DateTime-library-kotlinx-datetime.mjs.map
